var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs, _mask, _g2, _path11, _defs2, _mask2, _g3, _path12, _path13, _path14, _path15, _path16, _defs3, _mask3, _g4, _path17, _path18, _defs4, _mask4, _g5, _path19, _path20, _path21, _defs5, _mask5, _g6, _path22, _path23, _path24, _path25, _defs6, _mask6, _g7, _path26, _path27, _path28, _path29, _path30, _defs7, _mask7, _g8, _defs8, _mask8, _g9, _path31, _path32, _defs9, _mask9, _g10, _defs10, _mask10, _g11, _defs11, _mask11, _g12, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _defs12, _mask12, _g13, _path66, _path67, _path68, _path69, _path70, _path71, _defs13, _mask13, _g14, _path72, _path73, _path74, _path75, _defs14, _mask14, _g15, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _defs15, _mask15, _g16, _defs16, _mask16, _g17, _defs17, _mask17, _g18, _path84, _path85, _defs18, _mask18, _g19, _path86, _defs19, _mask19, _g20, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _defs20, _mask20, _g21, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _defs21, _mask21, _g22, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _defs22, _mask22, _g23, _path248, _defs23, _mask23, _g24, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _defs24, _mask24, _g25, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _defs25, _mask25, _g26, _defs26, _mask26, _g27, _defs27, _mask27, _g28, _path480, _defs28, _mask28, _g29, _defs29, _mask29, _g30, _path481, _g31, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _g32, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdrImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "147px",
    height: "107px",
    viewBox: "0 0 147 107",
    enableBackground: "new 0 0 147 107",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#132442",
    d: "M145.089,65.57c-0.344-0.197-0.704-0.365-1.075-0.502L83.473,42.47c-3.016-1.126-7.021-0.625-8.953,1.119 L35.726,78.607c-1.676,1.512-1.235,3.466,0.884,4.691c0.345,0.196,0.705,0.363,1.078,0.501l60.539,22.599 c3.016,1.127,7.023,0.623,8.953-1.119l38.793-35.019C147.65,68.746,147.208,66.801,145.089,65.57z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#898989",
    d: "M75.75,40.548l-0.001,1.146l-1.823,1.646l0.002-1.148L75.75,40.548z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8D8D8D",
    d: "M92.973,42.439l-0.003,1.146l-0.876-0.328l0.003-1.146L92.973,42.439z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8D8D8D",
    d: "M93.231,42.534l-0.002,1.146l-0.26-0.095l0.003-1.146L93.231,42.534z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3646",
    d: "M92.973,42.439l-0.003,1.146l-0.595,0.119l0.004-1.146L92.973,42.439z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M78.66,44.812l-0.004,1.146l-2.908-4.265l0.002-1.146L78.66,44.812z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    d: "M92.097,42.111l-0.004,1.146l-13.437,2.701l0.004-1.146L92.097,42.111z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3646",
    d: "M78.66,44.812l-0.004,1.146l-1.279,0.258l0.004-1.148L78.66,44.812z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3646",
    d: "M92.379,42.558l-0.004,1.146l-13.416,2.697l0.004-1.148L92.379,42.558z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3646",
    d: "M78.962,45.253l-0.004,1.148l-1.31,0.262l0.004-1.146L78.962,45.253z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M77.652,45.517l-0.004,1.146l-0.271-0.449l0.004-1.146L77.652,45.517z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 95.188,
    y: 45.193,
    width: 5.164,
    height: 1.811
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 95.188,
    y: 45.193,
    width: 5.164,
    height: 1.811,
    id: "mask0_1101_6094"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    filter: "url(#Adobe_OpacityMaskFilter)",
    d: "M96.708,46.797v-0.338c0-0.269,0-0.539,0-0.808 c1.214-0.161,2.427-0.314,3.64-0.458v1.146C99.137,46.482,97.923,46.635,96.708,46.797z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1101_6094)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8A8A8A",
    d: "M100.352,45.193v1.146c-1.721,0.203-3.447,0.427-5.164,0.665v-1.146 C96.904,45.62,98.631,45.396,100.352,45.193z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M95.188,45.858l-0.004,1.146l-1.954-3.323l0.002-1.146L95.188,45.858z"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_1_",
    filterUnits: "userSpaceOnUse",
    x: 95.188,
    y: 45.193,
    width: 5.164,
    height: 1.811
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 95.188,
    y: 45.193,
    width: 5.164,
    height: 1.811,
    id: "mask1_1101_6094"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    filter: "url(#Adobe_OpacityMaskFilter_1_)",
    d: "M96.708,46.797l-1.524,0.207v-1.146 c0.507-0.071,1.016-0.139,1.524-0.207C96.709,46.034,96.709,46.415,96.708,46.797z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1101_6094)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8A8A8A",
    d: "M100.352,45.193v1.146c-1.721,0.203-3.448,0.427-5.164,0.665v-1.146 C96.903,45.62,98.631,45.396,100.352,45.193z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M94.387,45.969l-0.004,1.148l-2.008-3.413l0.004-1.146L94.387,45.969z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#8D8D8D",
    d: "M103.709,46.446l-0.003,1.146l-3.356-1.252l0.002-1.146L103.709,46.446z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M95.627,46.603l-0.004,1.146l-0.439-0.746l0.004-1.146L95.627,46.603z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3646",
    d: "M95.627,46.603l-0.004,1.146l-0.777,0.154l0.002-1.146L95.627,46.603z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M94.848,46.757l-0.002,1.146l-0.463-0.786l0.004-1.148L94.848,46.757z"
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_2_",
    filterUnits: "userSpaceOnUse",
    x: 80.941,
    y: 45.967,
    width: 13.442,
    height: 3.346
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 80.941,
    y: 45.967,
    width: 13.442,
    height: 3.346,
    id: "mask2_1101_6094"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    filter: "url(#Adobe_OpacityMaskFilter_2_)",
    d: "M94.384,45.97v1.146c-4.593,0.65-9.134,1.404-13.442,2.197 v-1.148C85.251,47.374,89.791,46.62,94.384,45.97z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1101_6094)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8A8A8A",
    d: "M94.384,45.969v1.146c-4.593,0.65-9.134,1.404-13.442,2.197v-1.148c4.309-0.786,8.848-1.54,13.441-2.198 L94.384,45.969z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3646",
    d: "M91.244,47.375l-0.004,1.146l-1.541,0.333l0.004-1.146L91.244,47.375z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M91.668,48.033l-0.004,1.146l-0.424-0.657l0.004-1.146L91.668,48.033z"
  })), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_3_",
    filterUnits: "userSpaceOnUse",
    x: 91.668,
    y: 46.445,
    width: 12.041,
    height: 2.734
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 91.668,
    y: 46.445,
    width: 12.041,
    height: 2.734,
    id: "mask3_1101_6094"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    filter: "url(#Adobe_OpacityMaskFilter_3_)",
    d: "M103.709,46.445v1.146c-3.998,0.429-8.051,0.974-12.041,1.587 v-1.146C95.656,47.42,99.711,46.874,103.709,46.445z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1101_6094)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2C3342",
    d: "M103.709,46.445v1.146c-3.998,0.428-8.051,0.974-12.041,1.587v-1.146 C95.656,47.419,99.72,46.874,103.709,46.445z"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M80.943,48.161l-0.003,1.146l-1.981-2.906l0.004-1.148L80.943,48.161z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M90.074,48.282l-0.003,1.146l-0.372-0.573l0.004-1.146L90.074,48.282z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#8D8D8D",
    d: "M108.952,48.403l-0.005,1.146l-3.867-1.443l0.003-1.148L108.952,48.403z"
  })), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_4_",
    filterUnits: "userSpaceOnUse",
    x: 78.331,
    y: 48.16,
    width: 2.612,
    height: 1.633
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 78.331,
    y: 48.16,
    width: 2.612,
    height: 1.633,
    id: "mask4_1101_6094"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    filter: "url(#Adobe_OpacityMaskFilter_4_)",
    d: "M80.94,49.308c-0.88,0.159-1.753,0.322-2.613,0.485v-1.146 c0.86-0.163,1.733-0.326,2.613-0.487C80.943,48.504,80.941,48.963,80.94,49.308z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1101_6094)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2C3342",
    d: "M80.943,48.16v1.148c-0.879,0.159-1.752,0.322-2.612,0.485v-1.146 C79.191,48.483,80.064,48.321,80.943,48.16z"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M78.33,48.646l-0.001,1.148l-4.403-6.455l0.002-1.148L78.33,48.646z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#8D8D8D",
    d: "M115.545,50.864l-0.004,1.146l-1.339-0.5l0.001-1.146L115.545,50.864z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3646",
    d: "M108.822,51.587l-0.004,1.146l-0.627,0.143l0.004-1.146L108.822,51.587z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M108.195,51.73l-0.004,1.146l-3.111-4.77l0.003-1.148L108.195,51.73z"
  })), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_5_",
    filterUnits: "userSpaceOnUse",
    x: 63.317,
    y: 48.646,
    width: 15.014,
    height: 4.272
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 63.317,
    y: 48.646,
    width: 15.014,
    height: 4.272,
    id: "mask5_1101_6094"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    filter: "url(#Adobe_OpacityMaskFilter_5_)",
    d: "M78.331,48.646v1.146c-5.616,1.065-10.758,2.162-15.014,3.125 v-1.148C67.571,50.809,72.715,49.712,78.331,48.646z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1101_6094)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8A8A8A",
    d: "M78.331,48.646v1.146c-5.616,1.065-10.758,2.162-15.014,3.125v-1.148 C67.571,50.809,72.715,49.712,78.331,48.646z"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M109.125,52.029l-0.003,1.146l-0.304-0.441l0.004-1.146L109.125,52.029z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3646",
    d: "M109.125,52.029l-0.003,1.146l-0.64,0.146l0.004-1.146L109.125,52.029z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M108.831,52.704l-0.002,1.146l-0.347-0.529l0.004-1.146L108.831,52.704z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M95.191,53.462l-0.004,1.146l-3.522-5.429l0.003-1.146L95.191,53.462z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M93.654,53.795l-0.004,1.146l-3.579-5.513l0.003-1.146L93.654,53.795z"
  })), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_6_",
    filterUnits: "userSpaceOnUse",
    x: 95.195,
    y: 53.464,
    width: 0.172,
    height: 1.696
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 95.195,
    y: 53.464,
    width: 0.172,
    height: 1.696,
    id: "mask6_1101_6094"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    filter: "url(#Adobe_OpacityMaskFilter_6_)",
    d: "M95.367,54.014v1.146c-0.002-0.196-0.063-0.388-0.172-0.55 v-1.146C95.305,53.626,95.364,53.817,95.367,54.014z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1101_6094)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#858585",
    d: "M95.367,54.014v1.146c-0.002-0.196-0.063-0.388-0.172-0.55v-1.146 C95.305,53.626,95.364,53.817,95.367,54.014z"
  }))), _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_7_",
    filterUnits: "userSpaceOnUse",
    x: 95.041,
    y: 54.014,
    width: 0.326,
    height: 1.879
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 95.041,
    y: 54.014,
    width: 0.326,
    height: 1.879,
    id: "mask7_1101_6094"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    filter: "url(#Adobe_OpacityMaskFilter_7_)",
    d: "M95.367,54.014v1.146c-0.012,0.276-0.129,0.539-0.326,0.732 v-1.146C95.238,54.553,95.355,54.29,95.367,54.014z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1101_6094)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2A313F",
    d: "M95.367,54.014v1.146c-0.012,0.276-0.129,0.538-0.326,0.732v-1.146 C95.238,54.553,95.355,54.29,95.367,54.014z"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M108.195,51.73l-0.004,1.146l-13.158,3.021l0.004-1.146L108.195,51.73z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M93.096,54.554l-0.004,1.146l-6.668,1.646l0.004-1.146L93.096,54.554z"
  })), _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_8_",
    filterUnits: "userSpaceOnUse",
    x: 93.654,
    y: 53.795,
    width: 0.065,
    height: 1.357
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 93.654,
    y: 53.795,
    width: 0.065,
    height: 1.357,
    id: "mask8_1101_6094"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    filter: "url(#Adobe_OpacityMaskFilter_8_)",
    d: "M93.72,54.006v1.146c0-0.075-0.022-0.148-0.065-0.211v-1.146 C93.696,53.858,93.719,53.931,93.72,54.006z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1101_6094)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2A313F",
    d: "M93.72,54.006v1.146c0-0.075-0.022-0.148-0.065-0.211v-1.146C93.696,53.858,93.719,53.931,93.72,54.006z"
  }))), _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_9_",
    filterUnits: "userSpaceOnUse",
    x: 93.096,
    y: 54.006,
    width: 0.624,
    height: 1.693
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 93.096,
    y: 54.006,
    width: 0.624,
    height: 1.693,
    id: "mask9_1101_6094"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    filter: "url(#Adobe_OpacityMaskFilter_9_)",
    d: "M93.092,55.699c0-0.382,0-0.763,0-1.146 c0.389-0.097,0.625-0.317,0.625-0.55v1.146C93.72,55.385,93.48,55.604,93.092,55.699z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1101_6094)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#858585",
    d: "M93.72,54.006v1.146c0,0.196-0.167,0.381-0.452,0.492v-1.146C93.553,54.387,93.72,54.202,93.72,54.006z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8A8A8A",
    d: "M93.266,54.498v1.146c-0.055,0.023-0.111,0.041-0.17,0.055v-1.146c0.059-0.014,0.116-0.032,0.172-0.056 H93.266z"
  }))), _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_10_",
    filterUnits: "userSpaceOnUse",
    x: 60.75,
    y: 48.282,
    width: 29.325,
    height: 6.954
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 60.75,
    y: 48.282,
    width: 29.325,
    height: 6.954,
    id: "mask10_1101_6094"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    filter: "url(#Adobe_OpacityMaskFilter_10_)",
    d: "M90.074,48.282v1.146c-2.756,0.438-5.471,0.905-8.102,1.384 c-0.881,0.161-1.754,0.324-2.613,0.485c-7.303,1.382-13.827,2.821-18.61,3.938v-1.148c4.783-1.114,11.305-2.554,18.608-3.936 c0.862-0.163,1.734-0.324,2.615-0.485C84.604,49.187,87.315,48.72,90.074,48.282z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1101_6094)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2C3342",
    d: "M90.074,48.282v1.146c-2.756,0.438-5.471,0.905-8.102,1.384c-0.881,0.161-1.754,0.324-2.613,0.485 c-7.303,1.382-13.827,2.821-18.61,3.938v-1.148c4.783-1.114,11.305-2.554,18.608-3.937c0.862-0.162,1.734-0.324,2.615-0.485 C84.604,49.187,87.318,48.72,90.074,48.282z"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M86.428,56.199l-0.004,1.146l-4.455-6.531l0.003-1.148L86.428,56.199z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3645",
    d: "M86.428,56.199l-0.004,1.146l-2.52,0.623l0.004-1.148L86.428,56.199z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3646",
    d: "M95.037,54.752l-0.004,1.146l-9.271,2.13l0.004-1.148L95.037,54.752z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3646",
    d: "M108.486,52.175l-0.004,1.146l-21.445,4.924l0.004-1.146L108.486,52.175z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M108.831,52.704l-0.002,1.146l-5.099,1.172l0.002-1.146L108.831,52.704z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#8D8D8D",
    d: "M124.473,54.197l-0.004,1.146l-1.359-0.507l0.004-1.146L124.473,54.197z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#898989",
    d: "M63.316,51.772l-0.001,1.146l-2.569,2.318l0.004-1.146L63.316,51.772z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#8D8D8D",
    d: "M126.169,54.83l-0.004,1.146l-1.341-0.5l0.003-1.148L126.169,54.83z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M123.113,53.689l-0.004,1.146l-4.186,1.151l0.004-1.146L123.113,53.689z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    d: "M118.928,54.842l-0.004,1.146l-3.383-3.977l0.004-1.146L118.928,54.842z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    d: "M70.827,52.47l-0.004,1.146l-10.791,2.263l0.004-1.146L70.827,52.47z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A313F",
    d: "M118.188,55.045l-0.004,1.146l-3.981-4.681l0.001-1.146L118.188,55.045z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M118.928,54.842l-0.004,1.146l-0.74,0.204l0.004-1.146L118.928,54.842z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M124.473,54.197l-0.004,1.146l-4.937,1.358l0.002-1.146L124.473,54.197z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M119.533,55.555l-0.001,1.146l-0.741,0.203l0.001-1.146L119.533,55.555z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M72.81,55.758l-0.004,1.146l-1.983-3.288l0.003-1.146L72.81,55.758z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M118.188,55.045l-0.004,1.146l-4.156,1.143l0.004-1.146L118.188,55.045z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M114.031,56.188l-0.004,1.146l-5.08-7.785l0.004-1.146L114.031,56.188z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#898989",
    d: "M60.036,54.732l-0.004,1.146l-1.848,1.67l0.003-1.147L60.036,54.732z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M114.031,56.188l-0.004,1.146l-2.481,0.682l0.004-1.146L114.031,56.188z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M111.55,56.87l-0.004,1.146l-2.717-4.165l0.002-1.146L111.55,56.87z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M83.908,56.82l-0.004,1.148L79.355,51.3l0.004-1.148L83.908,56.82z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M118.792,55.758l-0.001,1.146l-4.275,1.176l0.004-1.146L118.792,55.758z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#898989",
    d: "M58.188,56.401l-0.004,1.147l-0.547,0.493l0.004-1.146L58.188,56.401z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3646",
    d: "M87.041,57.1l-0.004,1.146l-0.813,0.187l0.004-1.146L87.041,57.1z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3646",
    d: "M86.229,57.285l-0.004,1.146l-0.159,0.037l0.003-1.146L86.229,57.285z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M86.229,57.285l-0.159,0.037l-0.304-0.443l9.271-2.127l13.158-3.022l0.627-0.143l0.304,0.441l-0.64,0.146 L87.041,57.1L86.229,57.285z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M86.068,57.322l-0.003,1.146l-0.304-0.441l0.004-1.148L86.068,57.322z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M114.52,56.934l-0.004,1.146l-2.48,0.684l0.001-1.146L114.52,56.934z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3645",
    d: "M86.229,57.285l-0.004,1.146l-1.715,0.424l0.004-1.146L86.229,57.285z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M111.55,56.87l-0.004,1.146l-4.794,1.32l0.002-1.146L111.55,56.87z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#5C5C5C",
    d: "M106.754,58.19l-0.002,1.146l-3.021-4.313l0.004-1.146L106.754,58.19z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#656565",
    d: "M72.81,55.758l-0.003,1.146l-7.649,2.832l0.004-1.146L72.81,55.758z"
  })), _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_11_",
    filterUnits: "userSpaceOnUse",
    x: 62.795,
    y: 58.212,
    width: 2.366,
    height: 1.523
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 62.795,
    y: 58.212,
    width: 2.366,
    height: 1.523,
    id: "mask11_1101_6094"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    filter: "url(#Adobe_OpacityMaskFilter_11_)",
    d: "M65.158,59.736c-0.735-0.353-1.562-0.465-2.364-0.322v-1.146 c0.802-0.143,1.629-0.029,2.364,0.322C65.16,58.926,65.16,59.392,65.158,59.736z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1101_6094)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5D5D5D",
    d: "M65.161,58.59v1.146c-0.282-0.144-0.584-0.247-0.896-0.304v-1.146 C64.577,58.342,64.879,58.444,65.161,58.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#616161",
    d: "M64.259,58.285v1.146c-0.483-0.092-0.979-0.098-1.464-0.018v-1.146 C63.281,58.188,63.776,58.193,64.259,58.285z"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#8D8D8D",
    d: "M136.791,58.797l-0.002,1.146l-1.344-0.501l0.005-1.146L136.791,58.797z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M62.797,58.268l-0.003,1.146l-3.01,0.499l0.004-1.146L62.797,58.268z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#5C5C5C",
    d: "M59.787,58.768l-0.004,1.146l-1.599-2.364l0.003-1.147L59.787,58.768z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M83.908,56.82l-0.004,1.148l-8.145,2.009l0.004-1.146L83.908,56.82z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M106.754,58.19l-0.002,1.146l-15.973,4.394l0.002-1.146L106.754,58.19z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M106.146,58.804l-0.004,1.146l-0.75,0.195l0.004-1.146L106.146,58.804z"
  })), _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_12_",
    filterUnits: "userSpaceOnUse",
    x: 65.24,
    y: 58.633,
    width: 0.366,
    height: 1.416
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask13 || (_mask13 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 65.24,
    y: 58.633,
    width: 0.366,
    height: 1.416,
    id: "mask12_1101_6094"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    filter: "url(#Adobe_OpacityMaskFilter_12_)",
    d: "M65.605,58.902v1.146c-0.111-0.104-0.234-0.193-0.366-0.27 v-1.146C65.373,58.707,65.496,58.798,65.605,58.902z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1101_6094)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#858585",
    d: "M65.605,58.902v1.146c-0.111-0.104-0.234-0.193-0.366-0.27v-1.146 C65.373,58.707,65.496,58.798,65.605,58.902z"
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3646",
    d: "M59.787,58.768l-0.003,1.146l-0.791,0.132l0.002-1.146L59.787,58.768z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M58.995,58.898l-0.002,1.146l-1.356-2.003l0.004-1.146L58.995,58.898z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M112.036,57.617l-0.001,1.146l-5.618,1.545l0.004-1.146L112.036,57.617z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A303F",
    d: "M106.421,59.162l-0.004,1.146l-0.274-0.359l0.004-1.146L106.421,59.162z"
  })), _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_13_",
    filterUnits: "userSpaceOnUse",
    x: 63.024,
    y: 58.693,
    width: 1.879,
    height: 1.604
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask14 || (_mask14 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 63.024,
    y: 58.693,
    width: 1.879,
    height: 1.604,
    id: "mask13_1101_6094"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    filter: "url(#Adobe_OpacityMaskFilter_13_)",
    d: "M64.903,59.151v1.146c-0.075-0.071-0.158-0.132-0.247-0.183 c-0.502-0.26-1.076-0.346-1.632-0.246v-1.146c0.556-0.1,1.13-0.014,1.632,0.244C64.746,59.018,64.829,59.08,64.903,59.151z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1101_6094)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2A313F",
    d: "M64.903,59.151v1.146c-0.074-0.071-0.157-0.132-0.247-0.183c-0.202-0.114-0.421-0.193-0.649-0.232v-1.14 c0.229,0.04,0.449,0.118,0.651,0.231c0.089,0.051,0.171,0.111,0.245,0.183V59.151z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3342",
    d: "M64.006,58.743v1.146c-0.324-0.062-0.657-0.066-0.982-0.013V58.73c0.325-0.053,0.657-0.049,0.981,0.013 H64.006z"
  }))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3646",
    d: "M63.025,58.725l-0.003,1.146l-2.937,0.489l0.003-1.146L63.025,58.725z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A303F",
    d: "M105.678,59.365l-0.004,1.146l-0.281-0.367l0.004-1.146L105.678,59.365z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3646",
    d: "M60.088,59.214l-0.003,1.146l-0.791,0.132l0.002-1.148L60.088,59.214z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    d: "M58.995,58.898l-0.002,1.146l-4.379,0.727l0.002-1.146L58.995,58.898z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3645",
    d: "M84.514,57.709l-0.004,1.146l-8.102,2.001l0.004-1.146L84.514,57.709z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M139.139,59.672l-0.002,1.146l-1.32,0.332l0.002-1.146L139.139,59.672z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    d: "M137.818,60.005l-0.002,1.146l-1.027-1.208l0.002-1.146L137.818,60.005z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A313F",
    d: "M137.066,60.193l-0.004,1.148l-1.617-1.9l0.005-1.146L137.066,60.193z"
  })), _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_14_",
    filterUnits: "userSpaceOnUse",
    x: 74.143,
    y: 58.831,
    width: 1.619,
    height: 2.56
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask15 || (_mask15 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 74.143,
    y: 58.831,
    width: 1.619,
    height: 2.56,
    id: "mask14_1101_6094"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    filter: "url(#Adobe_OpacityMaskFilter_14_)",
    d: "M74.309,60.859c-0.107,0.158-0.167,0.346-0.17,0.537v-1.148 c0.004-0.191,0.063-0.377,0.168-0.536c0.258-0.401,0.772-0.712,1.449-0.881v1.146C75.081,60.146,74.566,60.459,74.309,60.859z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1101_6094)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8A8A8A",
    d: "M75.762,58.831v1.146c-0.155,0.038-0.308,0.086-0.456,0.145v-1.146c0.147-0.059,0.3-0.106,0.454-0.145 H75.762z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#858585",
    d: "M75.308,58.976v1.146c-0.399,0.135-0.747,0.391-0.995,0.732c-0.108,0.158-0.168,0.345-0.17,0.536v-1.146 c0.003-0.191,0.062-0.379,0.168-0.537C74.559,59.365,74.908,59.109,75.308,58.976L75.308,58.976z"
  }))), _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_15_",
    filterUnits: "userSpaceOnUse",
    x: 75.787,
    y: 59.708,
    width: 0.624,
    height: 1.694
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask16 || (_mask16 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 75.787,
    y: 59.708,
    width: 0.624,
    height: 1.694,
    id: "mask15_1101_6094"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    filter: "url(#Adobe_OpacityMaskFilter_15_)",
    d: "M75.787,61.402v-1.146c0.001-0.074,0.023-0.146,0.066-0.207 c0.137-0.18,0.336-0.301,0.558-0.341v1.146c-0.222,0.04-0.421,0.161-0.558,0.341C75.811,61.256,75.788,61.328,75.787,61.402z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1101_6094)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2C3342",
    d: "M76.411,59.708v1.146c-0.062,0.016-0.123,0.034-0.183,0.057v-1.146 C76.287,59.742,76.35,59.723,76.411,59.708z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A313F",
    d: "M76.233,59.766v1.146c-0.153,0.053-0.286,0.151-0.38,0.284c-0.043,0.061-0.065,0.133-0.066,0.207v-1.146 c0.001-0.074,0.023-0.146,0.066-0.207C75.947,59.916,76.08,59.816,76.233,59.766z"
  }))), _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_16_",
    filterUnits: "userSpaceOnUse",
    x: 75.785,
    y: 60.266,
    width: 0.106,
    height: 1.407
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask17 || (_mask17 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 75.785,
    y: 60.266,
    width: 0.106,
    height: 1.407,
    id: "mask16_1101_6094"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    filter: "url(#Adobe_OpacityMaskFilter_16_)",
    d: "M75.787,61.442c0-0.014,0-0.026,0-0.04v-1.146 c0,0.014,0,0.027,0,0.04C75.787,60.677,75.787,61.06,75.787,61.442z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1101_6094)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#858585",
    d: "M75.892,60.516v1.157c-0.065-0.071-0.104-0.164-0.106-0.262v-1.146c0.003,0.096,0.04,0.188,0.105,0.26 L75.892,60.516z"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#898989",
    d: "M54.616,59.626l-0.002,1.146l-0.675,0.608l0.003-1.146L54.616,59.626z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3646",
    d: "M59.296,59.344l-0.002,1.148l-5.356,0.888l0.003-1.146L59.296,59.344z"
  })), _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_17_",
    filterUnits: "userSpaceOnUse",
    x: 75.785,
    y: 60.265,
    width: 0.105,
    height: 1.408
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask18 || (_mask18 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 75.785,
    y: 60.265,
    width: 0.105,
    height: 1.408,
    id: "mask17_1101_6094"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    filter: "url(#Adobe_OpacityMaskFilter_17_)",
    d: "M75.787,61.442c0-0.092,0-0.183,0-0.274v-0.275 c0-0.199,0-0.398,0-0.597c0.012,0.082,0.047,0.158,0.103,0.22v1.157C75.833,61.608,75.797,61.527,75.787,61.442z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_1101_6094)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#858585",
    d: "M75.891,60.516v1.157c-0.065-0.071-0.104-0.165-0.105-0.262v-1.146c0.002,0.097,0.039,0.188,0.104,0.261 L75.891,60.516z"
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#8D8D8D",
    d: "M141.914,60.708l-0.003,1.146l-2.774-1.035l0.002-1.146L141.914,60.708z"
  })), _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_18_",
    filterUnits: "userSpaceOnUse",
    x: 74.143,
    y: 60.26,
    width: 0.271,
    height: 1.829
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask19 || (_mask19 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 74.143,
    y: 60.26,
    width: 0.271,
    height: 1.829,
    id: "mask18_1101_6094"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    filter: "url(#Adobe_OpacityMaskFilter_18_)",
    d: "M74.141,61.396V60.25c0.006,0.253,0.102,0.494,0.271,0.682 v1.148C74.244,61.891,74.147,61.649,74.141,61.396z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_1101_6094)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2A313F",
    d: "M74.414,60.941v1.147c-0.168-0.188-0.265-0.431-0.271-0.683V60.26 C74.148,60.512,74.245,60.754,74.414,60.941z"
  }))), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#898989",
    d: "M53.582,60.56l-0.003,1.146l-0.489,0.441l0.003-1.146L53.582,60.56z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A313F",
    d: "M139.036,61.434l-0.004,1.146l-1.216-1.429l0.002-1.146L139.036,61.434z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3645",
    d: "M141.915,60.708l-0.004,1.146l-2.878,0.727l0.003-1.146L141.915,60.708z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M141.915,60.708l-2.879,0.726l-1.218-1.429l1.32-0.333l0.944,0.354L141.915,60.708z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    d: "M131.85,61.508l-0.002,1.146l-5.683-6.678l0.004-1.146L131.85,61.508z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M137.064,60.193l-0.002,1.148l-5.215,1.313l0.002-1.146L137.064,60.193z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A313F",
    d: "M138.281,61.623l-0.002,1.146l-1.217-1.428l0.004-1.148L138.281,61.623z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M61.576,61.411l-0.003,1.147l-1.488-2.198l0.003-1.146L61.576,61.411z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A313F",
    d: "M131.096,61.699l-0.005,1.146l-6.267-7.368l0.003-1.148L131.096,61.699z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M60.839,61.627l-0.003,1.148l-1.541-2.283l0.002-1.148L60.839,61.627z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M90.781,62.583l-0.002,1.146l-3.742-5.484l0.004-1.146L90.781,62.583z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A313F",
    d: "M133.064,62.937l-0.002,1.146l-1.215-1.428l0.002-1.146L133.064,62.937z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M138.281,61.623l-5.215,1.313l-1.215-1.429l5.215-1.314L138.281,61.623z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3645",
    d: "M138.281,61.623l-0.002,1.146l-5.217,1.313l0.004-1.146L138.281,61.623z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M131.096,61.699l-0.005,1.146l-5.215,1.313l0.002-1.146L131.096,61.699z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    d: "M125.878,63.012l-0.002,1.146l-6.344-7.457l0.002-1.146L125.878,63.012z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A313F",
    d: "M132.311,63.127l-0.002,1.146l-1.218-1.429l0.003-1.146L132.311,63.127z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A313F",
    d: "M125.126,63.202l-0.004,1.146l-6.331-7.443l0.001-1.146L125.126,63.202z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M88.304,63.264L88.3,64.412l-3.79-5.557l0.004-1.146L88.304,63.264z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M90.781,62.583l-0.002,1.146L88.3,64.412l0.004-1.148L90.781,62.583z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M105.678,59.365l-0.004,1.146l-14.39,3.959l0.003-1.146L105.678,59.365z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    d: "M140.961,63.696l-0.003,1.147l-1.925-2.264l0.003-1.146L140.961,63.696z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M91.287,63.324l-0.003,1.146l-2.479,0.682l0.004-1.146L91.287,63.324z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A313F",
    d: "M140.453,64.156l-0.002,1.146l-2.172-2.533l0.002-1.146L140.453,64.156z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3241",
    d: "M140.961,63.696l-0.003,1.147l-0.507,0.459l0.002-1.146L140.961,63.696z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#898989",
    d: "M50.094,63.709l-0.004,1.146l-0.49,0.441l0.004-1.146L50.094,63.709z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3645",
    d: "M132.311,63.127l-0.002,1.146l-5.218,1.314l0.002-1.148L132.311,63.127z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M132.311,63.127l-5.218,1.313l-1.215-1.428l5.218-1.313L132.311,63.127z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A313F",
    d: "M127.093,64.439l-0.002,1.148l-1.217-1.43l0.004-1.146L127.093,64.439z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A313F",
    d: "M126.341,64.631l-0.004,1.146l-1.215-1.429l0.004-1.146L126.341,64.631z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M125.126,63.202l-0.004,1.146l-5.599,1.41l0.004-1.146L125.126,63.202z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M119.527,64.611l-0.004,1.146l-5.008-7.678l0.004-1.146L119.527,64.611z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M117.014,65.244l-0.002,1.146l-4.977-7.626l0.001-1.146L117.014,65.244z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M88.303,63.264L88.3,64.412l-8.209,2.258l0.004-1.148L88.303,63.264z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    d: "M80.095,65.521l-0.004,1.148l-4.201-5.006l0.003-1.146L80.095,65.521z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A313F",
    d: "M80.393,65.877l-0.004,1.146l-0.298-0.354l0.004-1.148L80.393,65.877z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A313F",
    d: "M78.611,65.93l-0.004,1.146l-4.196-4.996l0.003-1.146L78.611,65.93z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3645",
    d: "M126.341,64.631l-0.004,1.146l-5.839,1.47l0.002-1.146L126.341,64.631z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M120.5,66.101l-0.002,1.146l-0.975-1.488l0.004-1.146L120.5,66.101z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M90.303,66.197L90.3,67.344l-1.495-2.191l0.004-1.146L90.303,66.197z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M80.393,65.877l-0.004,1.146l-1.479,0.416l0.004-1.146L80.393,65.877z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A313F",
    d: "M78.914,66.293l-0.004,1.146l-0.303-0.363l0.004-1.146L78.914,66.293z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#838383",
    d: "M112.04,66.496l-0.002,1.148l-5.621-7.336l0.004-1.146L112.04,66.496z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M117.014,65.244l-0.002,1.146l-4.973,1.255l0.001-1.148L117.014,65.244z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    d: "M132.012,70.223l-0.003,1.146l-4.918-5.781l0.002-1.148L132.012,70.223z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A313F",
    d: "M128.057,66.646l-0.004,1.146l-1.716-2.017l0.004-1.146L128.057,66.646z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A303F",
    d: "M111.288,66.687l-0.002,1.146l-5.612-7.321l0.004-1.146L111.288,66.687z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M117.988,66.734l-0.004,1.146l-0.973-1.491l0.002-1.146L117.988,66.734z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M88.809,64.006l-0.004,1.146l-9.784,2.691l0.004-1.146L88.809,64.006z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#898989",
    d: "M46.799,66.684l-0.004,1.147l-0.194,0.174l0.003-1.146L46.799,66.684z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M90.303,66.197L90.3,67.344l-3.272,0.814l0.004-1.146L90.303,66.197z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M46.753,66.994l-0.002,1.148l-0.15-0.138l0.003-1.146L46.753,66.994z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#292F3D",
    d: "M46.799,66.684l-0.004,1.147l-0.044,0.312l0.002-1.148L46.799,66.684z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M78.61,65.93l-0.002,1.146l-4.353,1.197l0.003-1.146L78.61,65.93z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M74.26,67.128l-0.004,1.146l-8.652-8.225l0.004-1.146L74.26,67.128z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    d: "M136.861,67.398l-0.004,1.146l-3.795-4.463l0.004-1.146L136.861,67.398z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A3140",
    d: "M73.515,67.333l-0.004,1.146l-8.609-8.181l0.002-1.146L73.515,67.333z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "#898989",
    d: "M46.604,66.858l-0.003,1.146l-0.489,0.441l0.004-1.146L46.604,66.858z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M75.492,67.191l-0.003,1.148l-0.685,0.26l0.002-1.146L75.492,67.191z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3241",
    d: "M136.861,67.398l-0.004,1.146l-0.346,0.313l0.004-1.146L136.861,67.398z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M79.023,66.697l-0.003,1.146l-3.12,0.857l0.004-1.146L79.023,66.697z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M75.904,67.555L75.9,68.701l-0.412-0.361l0.004-1.148L75.904,67.555z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M75.156,67.762l-0.004,1.146L74.805,68.6l0.002-1.146L75.156,67.762z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A3140",
    d: "M74.83,67.67l-0.004,1.148l-0.57-0.545l0.003-1.146L74.83,67.67z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3241",
    d: "M136.516,67.712l-0.004,1.146l-0.173,0.155l0.004-1.148L136.516,67.712z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A313F",
    d: "M136.343,67.865l-0.004,1.148l-4.03-4.74l0.002-1.146L136.343,67.865z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A303F",
    d: "M113.154,67.95l-0.002,1.147l-1.113-1.453l0.001-1.148L113.154,67.95z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M117.988,66.734l-4.834,1.216l-1.113-1.454l4.973-1.252L117.988,66.734z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3645",
    d: "M117.986,66.734l-0.002,1.146l-4.832,1.217l0.002-1.147L117.986,66.734z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M46.643,67.777l-0.004,1.146l-0.527-0.478l0.004-1.146L46.643,67.777z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M74.83,67.67l-0.004,1.148l-0.701,0.246l0.004-1.146L74.83,67.67z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A3140",
    d: "M74.129,67.919l-0.004,1.146l-0.614-0.586l0.003-1.146L74.129,67.919z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M121.82,68.126l-0.002,1.146l-1.32-2.025l0.004-1.146L121.82,68.126z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M128.057,66.646l-0.002,1.146l-6.236,1.479l0.002-1.146L128.057,66.646z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A303F",
    d: "M112.402,68.141l-0.002,1.146l-1.113-1.454l0.001-1.146L112.402,68.141z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M69.333,68.482l-0.003,1.146l-7.757-7.07l0.003-1.147L69.333,68.482z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M73.515,67.333l-0.004,1.146l-4.181,1.15l0.003-1.146L73.515,67.333z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M68.585,68.688l-0.003,1.148l-7.746-7.061l0.003-1.148L68.585,68.688z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M75.156,67.762l-0.004,1.146l-5.08,1.396l0.002-1.146L75.156,67.762z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M70.074,69.158l-0.001,1.146l-0.743-0.676l0.003-1.146L70.074,69.158z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M69.326,69.363l-0.001,1.148l-0.743-0.676l0.003-1.148L69.326,69.363z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M134.477,69.551l-0.002,1.146l-2.465,0.672l0.002-1.146L134.477,69.551z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3241",
    d: "M134.477,69.551l-0.002,1.146l-0.244,0.219l0.004-1.146L134.477,69.551z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "#898989",
    d: "M46.116,67.3l-0.003,1.146l-2.474,2.233l0.002-1.146L46.116,67.3z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M68.585,68.688l-0.004,1.146l-4.644,1.278l0.004-1.146L68.585,68.688z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M63.94,69.966l-0.003,1.146l-10.359-9.406l0.004-1.146L63.94,69.966z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M63.197,70.175l-0.003,1.147l-10.104-9.175l0.003-1.146L63.197,70.175z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A313F",
    d: "M131.271,70.426l-0.004,1.146l-3.213-3.779l0.002-1.146L131.271,70.426z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M132.014,70.223l-0.004,1.146l-0.742,0.203l0.002-1.146L132.014,70.223z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M96.178,70.492l-0.004,1.146l-4.89-7.167l0.003-1.146L96.178,70.492z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M111.288,66.687l-0.001,1.146l-15.113,3.805l0.004-1.146L111.288,66.687z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M69.326,69.363l-0.002,1.148l-4.644,1.276l0.003-1.146L69.326,69.363z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M64.684,70.642l-0.004,1.146l-0.743-0.676l0.004-1.146L64.684,70.642z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M63.937,70.847l-0.004,1.146l-0.739-0.671l0.003-1.147L63.937,70.847z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M63.937,70.847l-0.004,1.146l-0.049,0.015l0.002-1.146L63.937,70.847z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3241",
    d: "M134.234,69.77l-0.004,1.146l-1.433,1.293l0.005-1.146L134.234,69.77z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M132.803,71.063l-0.004,1.146l-0.802,0.22l0.002-1.147L132.803,71.063z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3241",
    d: "M132.76,71.102l-0.004,1.146l-0.143,0.127l0.004-1.146L132.76,71.102z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M93.665,71.125l-0.004,1.146L90.3,67.344l0.004-1.146L93.665,71.125z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M132.741,71.079l0.019,0.022l-0.143,0.128l-0.375,0.339l-0.243-0.287L132.741,71.079z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3241",
    d: "M132.617,71.229l-0.004,1.146l-0.375,0.34l0.004-1.146L132.617,71.229z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A313F",
    d: "M132.242,71.568l-0.004,1.146l-0.241-0.286l0.002-1.147L132.242,71.568z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M80.355,71.477l-0.001,1.146L75.9,68.701l0.004-1.146L80.355,71.477z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "#909090",
    d: "M63.198,70.175l-0.003,1.147l-4.33,1.502l0.004-1.146L63.198,70.175z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M58.868,71.678l-0.003,1.146l-8.774-7.969l0.004-1.146L58.868,71.678z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M80.356,71.477l-0.002,1.146l-0.687,0.26l0.004-1.146L80.356,71.477z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M79.672,71.736l-0.004,1.146l-4.516-3.975l0.004-1.146L79.672,71.736z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "#838383",
    d: "M90.859,71.832l-0.004,1.146l-3.828-4.82l0.004-1.146L90.859,71.832z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M93.664,71.125l-0.003,1.146l-2.806,0.707l0.004-1.146L93.664,71.125z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3645",
    d: "M112.402,68.141l-0.002,1.146l-15.217,3.832l0.004-1.146L112.402,68.141z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M97.188,71.973l-0.004,1.146l-1.01-1.481l0.004-1.146L97.188,71.973z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M58.162,71.922l-0.004,1.146L49.6,65.297l0.004-1.146L58.162,71.922z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "#292F3D",
    d: "M46.643,67.777l-0.004,1.146l-0.591,4.146l0.004-1.146L46.643,67.777z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M131.27,70.426l-0.002,1.146l-6.748,1.84l0.004-1.148L131.27,70.426z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "#5B5B5B",
    d: "M124.523,72.264l-0.004,1.148l-2.701-4.141l0.002-1.146L124.523,72.264z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M59.606,72.347l-0.004,1.146l-0.737-0.668l0.004-1.146L59.606,72.347z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M63.886,70.861l-0.002,1.146l-4.282,1.484l0.003-1.146L63.886,70.861z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "#898989",
    d: "M43.64,69.533l-0.001,1.146l-5.519,4.982l0.002-1.147L43.64,69.533z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "#5A5A5A",
    d: "M43.64,69.533l-0.002,1.146l-0.399,2.801l0.003-1.146L43.64,69.533z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M94.675,72.604l-0.003,1.148l-1.011-1.481l0.003-1.146L94.675,72.604z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M110.572,70.139l-0.002,1.146l-10.258,2.523l0.004-1.146L110.572,70.139z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M58.899,72.592l-0.004,1.146l-0.737-0.67l0.004-1.146L58.899,72.592z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M124.523,72.264l-0.004,1.148l-2.484,0.678l0.002-1.148L124.523,72.264z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M122.037,72.941l-0.002,1.148l-4.051-6.209l0.004-1.146L122.037,72.941z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M90.859,71.832l-0.004,1.146l-4.404,1.109l0.002-1.146L90.859,71.832z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M131.998,71.281l-0.001,1.147l-6.894,1.879l0.004-1.148L131.998,71.281z"
  })), _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_19_",
    filterUnits: "userSpaceOnUse",
    x: 85.297,
    y: 72.939,
    width: 1.156,
    height: 1.449
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask20 || (_mask20 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 85.297,
    y: 72.939,
    width: 1.156,
    height: 1.449,
    id: "mask19_1101_6094"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    filter: "url(#Adobe_OpacityMaskFilter_19_)",
    d: "M85.303,74.387c0-0.384,0-0.767,0-1.148 c0.379-0.101,0.761-0.201,1.145-0.299v1.146C86.066,74.184,85.684,74.283,85.303,74.387z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_1101_6094)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#616161",
    d: "M86.453,72.939v1.146c-0.389,0.1-0.772,0.199-1.156,0.303v-1.146c0.382-0.104,0.768-0.203,1.154-0.303 H86.453z"
  }))), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "#5D5D5D",
    d: "M85.299,73.242l-0.002,1.146l-6.276-6.545l0.004-1.146L85.299,73.242z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "#909090",
    d: "M58.162,71.922l-0.003,1.146l-4.328,1.501l0.003-1.146L58.162,71.922z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M53.834,73.423l-0.004,1.146l-7.08-6.427l0.002-1.148L53.834,73.423z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M125.107,73.16l-0.004,1.147l-2.484,0.678l0.003-1.148L125.107,73.16z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M53.13,73.668l-0.004,1.146l-6.487-5.891l0.003-1.146L53.13,73.668z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M122.037,72.941l-0.002,1.146l-4.184,1.143l0.004-1.148L122.037,72.941z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "#838383",
    d: "M117.855,74.082l-0.004,1.148l-4.699-6.133l0.002-1.147L117.855,74.082z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M54.572,74.094l-0.004,1.146l-0.737-0.671l0.003-1.146L54.572,74.094z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M58.899,72.592l-0.003,1.146l-4.328,1.502l0.003-1.146L58.899,72.592z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M53.834,73.423l4.328-1.501l0.737,0.67l-4.328,1.502L53.834,73.423z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A303F",
    d: "M117.113,74.285l-0.002,1.146l-4.711-6.145l0.002-1.146L117.113,74.285z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3645",
    d: "M94.675,72.604l-0.004,1.148l-7.122,1.792l0.004-1.146L94.675,72.604z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M53.867,74.339l-0.004,1.146l-0.737-0.67l0.003-1.146L53.867,74.339z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A303F",
    d: "M118.191,74.525v1.146l-0.34-0.441l0.002-1.148L118.191,74.525z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A303F",
    d: "M117.443,74.718l-0.002,1.146l-0.33-0.433l0.002-1.146L117.443,74.718z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M118.191,74.525l-0.002,1.146l-0.748,0.192l0.002-1.146L118.191,74.525z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M111.288,66.687l-5.61-7.321l-0.281-0.367l0.75-0.194l0.274,0.358l5.619,7.334l1.114,1.455l4.699,6.131 l0.338,0.443l-0.748,0.192l-0.33-0.433l-4.711-6.145L111.288,66.687z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M117.113,74.285l-0.002,1.146l-2.592,0.705l0.004-1.146L117.113,74.285z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    d: "M114.523,74.99l-0.004,1.146l-3.949-4.853l0.002-1.146L114.523,74.99z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "#909090",
    d: "M53.13,73.668l-0.004,1.146l-3.66,1.27l0.004-1.146L53.13,73.668z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M49.47,74.938l-0.004,1.146l-3.418-3.014l0.004-1.146L49.47,74.938z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M49.47,74.938l-0.004,1.146l-1.151,0.398l0.003-1.146L49.47,74.938z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M53.867,74.339l-0.004,1.146l-3.643,1.264l0.004-1.146L53.867,74.339z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M77.428,75.858l-0.004,1.148l-7.351-6.702l0.002-1.146L77.428,75.858z"
  })), _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_20_",
    filterUnits: "userSpaceOnUse",
    x: 77.426,
    y: 73.242,
    width: 7.877,
    height: 3.763
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask21 || (_mask21 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 77.426,
    y: 73.242,
    width: 7.877,
    height: 3.763,
    id: "mask20_1101_6094"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    filter: "url(#Adobe_OpacityMaskFilter_20_)",
    d: "M77.423,77.005c0-0.366,0-0.778,0-1.146 c2.568-1.028,5.196-1.902,7.868-2.616v1.146C82.619,75.102,79.991,75.976,77.423,77.005z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_1101_6094)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8A8A8A",
    d: "M85.303,73.242v1.146c-2.501,0.668-4.963,1.475-7.373,2.418V75.66C80.34,74.717,82.802,73.91,85.303,73.242 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#858585",
    d: "M77.926,75.66v1.146l-0.5,0.198v-1.146L77.926,75.66z"
  }))), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M114.523,74.99l-0.004,1.146l-10.518,2.869l0.002-1.146L114.523,74.99z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3646",
    d: "M113.166,75.91l-0.004,1.148l-0.77,0.166l0.002-1.146L113.166,75.91z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M127.098,76.212l-0.004,1.146l-1.99-3.051l0.004-1.147L127.098,76.212z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A3140",
    d: "M49.025,76.018l-0.003,1.148l-0.707-0.684l0.003-1.146L49.025,76.018z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M50.224,75.602l-0.003,1.146l-1.199,0.418l0.003-1.148L50.224,75.602z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M76.756,76.135l-0.004,1.146l-7.428-6.77l0.002-1.148L76.756,76.135z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M113.445,76.34l-0.004,1.146l-0.279-0.428l0.004-1.148L113.445,76.34z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M122.622,73.837l-0.003,1.148l-9.178,2.501l0.004-1.146L122.622,73.837z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3241",
    d: "M127.098,76.212l-0.002,1.146l-0.378,0.339l0.003-1.146L127.098,76.212z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M112.699,76.543l-0.004,1.146l-0.303-0.465l0.002-1.146L112.699,76.543z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M78.901,77.203l-0.003,1.146l-1.474-1.342l0.002-1.148L78.901,77.203z"
  })), _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_21_",
    filterUnits: "userSpaceOnUse",
    x: 78.902,
    y: 74.397,
    width: 8.648,
    height: 3.951
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask22 || (_mask22 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 78.902,
    y: 74.397,
    width: 8.648,
    height: 3.951,
    id: "mask21_1101_6094"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    filter: "url(#Adobe_OpacityMaskFilter_21_)",
    d: "M87.551,74.398v1.146c-2.944,0.734-5.835,1.672-8.65,2.804 v-1.146C81.716,76.07,84.606,75.133,87.551,74.398z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_1101_6094)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2C3342",
    d: "M87.551,74.398v1.146c-2.742,0.682-5.438,1.539-8.07,2.564v-1.148 C82.113,75.936,84.809,75.079,87.551,74.398L87.551,74.398z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A313F",
    d: "M79.482,76.971v1.147c-0.194,0.075-0.389,0.153-0.58,0.23v-1.146L79.482,76.971z"
  }))), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M90.56,77.166l-0.003,1.148l-0.722,0.223l0.002-1.146L90.56,77.166z"
  })), _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_22_",
    filterUnits: "userSpaceOnUse",
    x: 34.704,
    y: 74.111,
    width: 2.984,
    height: 4.324
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask23 || (_mask23 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 34.704,
    y: 74.111,
    width: 2.984,
    height: 4.324,
    id: "mask22_1101_6094"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    filter: "url(#Adobe_OpacityMaskFilter_22_)",
    d: "M34.7,75.258v-1.146c0,0.985,0.663,1.956,1.907,2.674 c0.344,0.197,0.705,0.366,1.078,0.504v1.146c-0.373-0.139-0.733-0.307-1.078-0.504C35.362,77.213,34.698,76.243,34.7,75.258z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_1101_6094)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#858585",
    d: "M37.688,77.289v1.146c-0.373-0.139-0.733-0.307-1.078-0.504c-1.244-0.719-1.909-1.688-1.907-2.674v-1.146 c0,0.985,0.663,1.956,1.907,2.674C36.955,76.982,37.315,77.151,37.688,77.289z"
  }))), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M78.23,77.479l-0.004,1.146l-1.475-1.344l0.003-1.146L78.23,77.479z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3646",
    d: "M107.438,77.468l-0.002,1.146l-0.763,0.174l0.005-1.146L107.438,77.468z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M125.255,77.875l-0.001,1.146l-2.635-4.036l0.003-1.148L125.255,77.875z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3241",
    d: "M126.721,76.551l-0.003,1.146l-1.464,1.324l0.002-1.146L126.721,76.551z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "#5C5C5C",
    d: "M104.004,77.859l-0.002,1.146l-3.689-5.198l0.004-1.146L104.004,77.859z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M112.699,76.543l-0.004,1.146l-4.967,1.355l0.004-1.146L112.699,76.543z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M107.732,77.898l-0.004,1.146l-0.293-0.431l0.002-1.146L107.732,77.898z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F8F8F",
    d: "M76.755,76.135l-0.003,1.146l-4.127,1.721l0.004-1.146L76.755,76.135z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M72.628,77.856l-0.003,1.146l-7.945-7.214l0.003-1.146L72.628,77.856z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M106.99,78.1l-0.004,1.146l-0.313-0.458l0.005-1.146L106.99,78.1z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M71.96,78.135l-0.001,1.146l-8.026-7.288l0.004-1.146L71.96,78.135z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M101.641,78.504l-0.004,1.146l-4.453-6.531l0.004-1.146L101.641,78.504z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M104.004,77.859l-0.002,1.146l-2.363,0.645l0.002-1.146L104.004,77.859z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M101.641,78.504l-0.004,1.146l-1.67,0.456l0.004-1.146L101.641,78.504z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M99.971,78.961l-0.004,1.146l-0.771,0.276l0.004-1.146L99.971,78.961z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M99.199,79.236l-0.004,1.146l-4.523-6.63l0.004-1.148L99.199,79.236z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M74.109,79.2l-0.004,1.146l-1.48-1.345l0.004-1.146L74.109,79.2z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M78.23,77.479l-4.123,1.72l-1.479-1.342l4.104-1.714h0.021L78.23,77.479z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3544",
    d: "M78.23,77.479l-0.004,1.146l-4.121,1.722l0.004-1.146L78.23,77.479z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M106.99,78.1l-0.004,1.146l-4.741,1.293l0.002-1.146L106.99,78.1z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M73.441,79.479l-0.004,1.146l-1.479-1.344l0.002-1.146L73.441,79.479z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M51.291,79.432l-0.003,1.146l-8.048-7.097l0.003-1.146L51.291,79.432z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "#636363",
    d: "M51.291,79.432l-0.004,1.146L38.12,75.662l0.002-1.147L51.291,79.432z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M102.247,79.393l-0.002,1.146l-1.532,0.417l0.004-1.146L102.247,79.393z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F8F8F",
    d: "M71.961,78.135l-0.002,1.146l-4.099,1.711l0.003-1.147L71.961,78.135z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M67.864,79.845l-0.003,1.147l-8.258-7.5l0.003-1.146L67.864,79.845z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M100.717,79.811l-0.003,1.146l-0.904,0.328l0.003-1.146L100.717,79.811z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M67.196,80.125l-0.004,1.146l-8.296-7.533l0.004-1.146L67.196,80.125z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "#909090",
    d: "M99.199,79.236l-0.004,1.146l-5.021,1.824l0.002-1.146L99.199,79.236z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    d: "M94.176,81.061l-0.002,1.146l-3.617-3.893l0.003-1.148L94.176,81.061z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M69.342,81.189l-0.003,1.146l-1.479-1.343l0.003-1.147L69.342,81.189z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3544",
    d: "M73.441,79.479l-0.003,1.146l-4.099,1.71l0.003-1.146L73.441,79.479z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A313F",
    d: "M93.479,81.313l-0.004,1.147l-3.64-3.924l0.002-1.146L93.479,81.313z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A313F",
    d: "M94.58,81.494l-0.004,1.148l-0.404-0.436l0.004-1.146L94.58,81.494z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M68.675,81.467l-0.004,1.146l-1.479-1.342l0.003-1.146L68.675,81.467z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M56.969,81.551l-0.002,1.146l-6.747-5.949l0.004-1.146L56.969,81.551z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3444",
    d: "M56.969,81.551l-0.003,1.146l-5.678-2.12l0.004-1.146L56.969,81.551z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A313F",
    d: "M93.855,81.722l-0.004,1.146l-0.377-0.406l0.004-1.147L93.855,81.722z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M94.58,81.494l-0.004,1.148l-0.725,0.225l0.004-1.146L94.58,81.494z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M63.097,81.835l-0.003,1.146l-8.525-7.741l0.003-1.146L63.097,81.835z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F8F8F",
    d: "M67.196,80.125l-0.003,1.146l-4.099,1.71l0.003-1.146L67.196,80.125z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M62.431,82.113l-0.003,1.146l-8.564-7.775l0.003-1.146L62.431,82.113z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M120.402,82.256l-0.004,1.146l-2.694,0.617l0.003-1.148L120.402,82.256z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3241",
    d: "M120.402,82.256l-0.004,1.146l-0.387,0.35l0.004-1.146L120.402,82.256z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "#909090",
    d: "M93.479,81.313l-0.004,1.147l-7.199,2.613l0.004-1.146L93.479,81.313z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M91.727,82.515l-0.004,1.147l-0.7,0.25l0.003-1.146L91.727,82.515z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M117.707,82.871l-0.003,1.148l-4.263-6.533l0.004-1.146L117.707,82.871z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A3140",
    d: "M92.157,82.919l-0.003,1.146l-0.431-0.403l0.003-1.147L92.157,82.919z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M99.813,80.138l-0.003,1.146l-7.656,2.781l0.004-1.146L99.813,80.138z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M116.941,83.047l-0.002,1.146l-4.244-6.504l0.004-1.146L116.941,83.047z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F8F8F",
    d: "M62.431,82.113l-0.003,1.146l-1.867,0.78l0.004-1.148L62.431,82.113z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A3140",
    d: "M91.46,83.172l-0.004,1.146l-0.434-0.406l0.003-1.146L91.46,83.172z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M64.575,83.18l-0.003,1.146l-1.479-1.345l0.003-1.146L64.575,83.18z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3544",
    d: "M68.674,81.467l-0.003,1.146l-4.099,1.713l0.003-1.146L68.674,81.467z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M63.909,83.457l-0.003,1.146l-1.479-1.344l0.004-1.146L63.909,83.457z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3241",
    d: "M120.016,82.605l-0.004,1.146l-1.135,1.023l0.004-1.146L120.016,82.605z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M118.289,83.766l-0.003,1.146l-0.582-0.893l0.003-1.148L118.289,83.766z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3646",
    d: "M118.88,83.63l-0.003,1.146l-0.591,0.137l0.003-1.146L118.88,83.63z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M117.525,83.939l-0.002,1.146l-0.584-0.893l0.004-1.146L117.525,83.939z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3444",
    d: "M63.044,83.818l-0.004,1.146l-2.479-0.925l0.004-1.148L63.044,83.818z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3544",
    d: "M63.91,83.455l-0.004,1.148l-0.865,0.361l0.004-1.146L63.91,83.455z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M118.454,84.014l-0.004,1.148l-0.162-0.25l0.001-1.146L118.454,84.014z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M86.279,83.928l-0.004,1.146l-7.377-6.726l0.004-1.146L86.279,83.928z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M116.941,83.047l-0.002,1.146l-4.912,1.125l0.004-1.146L116.941,83.047z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M112.031,84.172l-0.004,1.146l-4.299-6.273l0.004-1.146L112.031,84.172z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3241",
    d: "M118.454,84.014l-0.004,1.148l-0.274,0.248l0.002-1.146L118.454,84.014z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M85.582,84.181l-0.003,1.146l-7.353-6.702l0.004-1.146L85.582,84.181z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M86.279,83.928l-0.004,1.146l-0.697,0.253l0.004-1.146L86.279,83.928z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M111.268,84.346l-0.002,1.148l-4.279-6.248l0.004-1.146L111.268,84.346z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M117.898,84.514l-0.002,1.146l-0.375-0.574l0.002-1.146L117.898,84.514z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M116.943,83.047l-4.244-6.504l-0.303-0.465l0.77-0.168l0.279,0.43l4.263,6.531l0.581,0.895l0.165,0.248 l-0.276,0.25l-0.277,0.25l-0.375-0.574L116.943,83.047z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3241",
    d: "M118.178,84.264l-0.002,1.146l-0.279,0.25l0.004-1.146L118.178,84.264z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M66.843,85.235l-0.004,1.146l-2.267-2.056l0.003-1.146L66.843,85.235z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M65.19,84.62l-0.004,1.146l-1.281-1.163l0.003-1.146L65.19,84.62z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M91.46,83.172l-0.004,1.146l-4.296,1.561l0.003-1.146L91.46,83.172z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M112.639,85.059l-0.004,1.146l-0.607-0.886l0.004-1.146L112.639,85.059z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3646",
    d: "M117.525,83.939l-0.002,1.146l-4.889,1.118l0.004-1.146L117.525,83.939z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M87.163,84.732l-0.003,1.146l-0.697,0.254l0.004-1.146L87.163,84.732z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M111.876,85.234l-0.004,1.146l-0.606-0.886l0.002-1.148L111.876,85.234z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3444",
    d: "M66.843,85.235l-0.003,1.146l-1.652-0.615l0.004-1.146L66.843,85.235z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M106.389,85.463l-0.002,1.148l-4.142-6.072l0.002-1.146L106.389,85.463z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M111.268,84.346l-0.002,1.148l-4.879,1.117l0.002-1.148L111.268,84.346z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3646",
    d: "M106.389,85.463l-0.002,1.148l-1.275,0.291l0.002-1.146L106.389,85.463z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3646",
    d: "M105.115,85.756l-0.002,1.146l-0.066,0.014l0.004-1.146L105.115,85.756z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M81.305,85.733l-0.002,1.148l-7.197-6.535l0.004-1.146L81.305,85.733z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fill: "#909090",
    d: "M85.582,84.181l-0.004,1.146l-4.275,1.555l0.002-1.148L85.582,84.181z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M81.305,85.733l-0.002,1.148l-0.697,0.253l0.003-1.148L81.305,85.733z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M80.609,85.986l-0.004,1.148l-7.168-6.51l0.004-1.146L80.609,85.986z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M103.925,86.166l-0.004,1.146l-4.111-6.028l0.003-1.146L103.925,86.166z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M105.05,85.77l-0.003,1.146l-1.126,0.396l0.004-1.146L105.05,85.77z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3646",
    d: "M111.875,85.234l-0.003,1.146l-4.882,1.117l0.003-1.146L111.875,85.234z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M86.467,84.986l-0.004,1.146l-4.277,1.553l0.004-1.146L86.467,84.986z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3646",
    d: "M106.994,86.351l-0.004,1.146l-1.206,0.276l0.004-1.146L106.994,86.351z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M82.189,86.539l-0.004,1.146l-0.695,0.252l0.004-1.146L82.189,86.539z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M105.788,86.627l-0.004,1.146l-1.248,0.439l0.002-1.148L105.788,86.627z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fill: "#909090",
    d: "M80.609,85.986l-0.004,1.148l-4.275,1.551l0.004-1.146L80.609,85.986z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M76.334,87.539l-0.004,1.146l-6.991-6.351l0.003-1.146L76.334,87.539z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M114.419,87.656l-0.003,1.148l-1.781-2.601l0.004-1.146L114.419,87.656z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M75.639,87.792l-0.004,1.146l-6.964-6.324l0.004-1.146L75.639,87.792z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M76.334,87.539l-0.004,1.146l-0.695,0.252l0.004-1.146L76.334,87.539z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M113.872,88.148l-0.002,1.148l-1.998-2.917l0.004-1.146L113.872,88.148z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3241",
    d: "M114.419,87.656l-0.004,1.146l-0.545,0.494l0.002-1.148L114.419,87.656z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fill: "#909090",
    d: "M75.639,87.792l-0.004,1.146l-0.988,0.359l0.004-1.146L75.639,87.792z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fill: "#909090",
    d: "M103.925,86.166l-0.004,1.146l-6.046,2.125l0.002-1.146L103.925,86.166z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M97.877,88.291l-0.002,1.146l-5.722-5.372l0.004-1.146L97.877,88.291z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M99.813,80.138l4.111,6.028l-6.048,2.125l-5.72-5.372L99.813,80.138z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M81.494,86.792l-0.003,1.146l-4.272,1.551l0.002-1.146L81.494,86.792z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A3140",
    d: "M97.176,88.539l-0.004,1.146l-5.716-5.367l0.003-1.146L97.176,88.539z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M77.221,88.343l-0.002,1.146l-0.697,0.253l0.004-1.146L77.221,88.343z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M76.525,88.596l-0.004,1.146l-0.346,0.126l0.004-1.146L76.525,88.596z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M69.342,81.189l4.099-1.711l7.168,6.508l-4.275,1.553L69.342,81.189z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M92.964,90.019l-0.003,1.147l-5.801-5.287l0.002-1.146L92.964,90.019z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M76.179,88.723L74.65,88.15l0.988-0.358l0.695-0.253l4.275-1.553l0.695-0.253l4.277-1.553l0.697-0.253 l7.199-2.614l0.377,0.408l0.725-0.228l-0.404-0.434l5.023-1.824l0.728-0.266l1.714-0.467l2.363-0.645l10.52-2.869l2.59-0.705 l0.33,0.433l0.748-0.192l-0.338-0.443l4.184-1.141l2.486-0.678l6.746-1.838l0.744-0.203l2.463-0.672l-0.242,0.219l-1.432,1.293 l-0.804,0.219l-6.892,1.878l-2.485,0.678l-9.177,2.503l-0.279-0.43l-0.771,0.168l0.305,0.465l-4.967,1.355l-0.295-0.431l-0.76,0.175 l0.313,0.457l-4.743,1.293l-1.53,0.418l-0.903,0.327l-7.656,2.781l-0.431-0.404l-0.7,0.251l0.434,0.406l-4.296,1.561l-0.697,0.254 l-4.277,1.553l-0.695,0.253l-4.273,1.551l-0.695,0.253L76.179,88.723z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3444",
    d: "M76.179,88.723l-0.004,1.146l-1.528-0.571l0.004-1.146L76.179,88.723z"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M77,89.027l-0.002,1.146l-0.477-0.432l0.004-1.146L77,89.027z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fill: "#636363",
    d: "M76.689,88.912l-0.004,1.146l-0.51-0.19l0.004-1.146L76.689,88.912z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fill: "#636363",
    d: "M77,89.027l-0.002,1.146l-0.313-0.115l0.004-1.146L77,89.027z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A3140",
    d: "M98.742,89.103l-0.003,1.146l-0.864-0.812l0.002-1.146L98.742,89.103z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M104.538,87.064l-0.002,1.148l-5.797,2.036l0.003-1.146L104.538,87.064z"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A3140",
    d: "M98.04,89.35l-0.003,1.146l-0.864-0.811l0.003-1.146L98.04,89.35z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M78.654,89.645l-0.004,1.148l-1.432-1.304l0.002-1.146L78.654,89.645z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3444",
    d: "M78.35,89.531l-0.004,1.146l-1.348-0.504L77,89.027L78.35,89.531z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3444",
    d: "M78.654,89.645l-0.004,1.148l-0.305-0.115l0.004-1.146L78.654,89.645z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fill: "#909090",
    d: "M97.175,88.539l-0.002,1.146l-4.212,1.48l0.004-1.147L97.175,88.539z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M92.964,90.019l-0.003,1.147l-0.705,0.248l0.004-1.146L92.964,90.019z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M92.26,90.268l-0.004,1.146l-5.793-5.281l0.004-1.146L92.26,90.268z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M98.04,89.35l-0.003,1.146l-4.193,1.475l0.002-1.146L98.04,89.35z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M93.846,90.824l-0.002,1.146l-0.704,0.246l0.003-1.146L93.846,90.824z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M110.375,91.308l-0.004,1.146l-3.381-4.956l0.003-1.146L110.375,91.308z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M87.961,91.778l-0.004,1.146l-5.771-5.238l0.004-1.146L87.961,91.778z"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fill: "#909090",
    d: "M92.26,90.268l-0.004,1.146l-4.299,1.51l0.004-1.146L92.26,90.268z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M87.258,92.025l-0.003,1.146l-5.765-5.233l0.004-1.146L87.258,92.025z"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M87.961,91.778l-0.004,1.146l-0.702,0.248l0.003-1.146L87.961,91.778z"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M87.259,92.025l-5.765-5.233l0.695-0.253l5.771,5.239L87.259,92.025z"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fill: "#909090",
    d: "M87.258,92.025l-0.003,1.146l-1.147,0.402l0.002-1.146L87.258,92.025z"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M93.144,91.071l-0.004,1.146l-4.296,1.512l0.003-1.146L93.144,91.071z"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M88.848,92.582l-0.004,1.146l-0.703,0.247l0.004-1.146L88.848,92.582z"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3241",
    d: "M110.375,91.308l-0.004,1.146l-1.82,1.645l0.004-1.146L110.375,91.308z"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fill: "#29303E",
    d: "M108.555,92.951l-0.004,1.146l-4.015-5.885l0.002-1.148L108.555,92.951z"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3444",
    d: "M87.65,93.003l-0.004,1.146l-1.541-0.575l0.004-1.146L87.65,93.003z"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3545",
    d: "M88.145,92.829l-0.004,1.146l-0.494,0.174l0.004-1.146L88.145,92.829z"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M88.813,93.438l-0.002,1.146l-0.67-0.608l0.004-1.146L88.813,93.438z"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M90.469,94.057l-0.002,1.146l-1.623-1.474l0.003-1.146L90.469,94.057z"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3444",
    d: "M90.468,94.057l-0.001,1.146l-1.656-0.618l0.002-1.146L90.468,94.057z"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M105.641,95.581l-0.002,1.146l-6.899-6.479l0.003-1.146L105.641,95.581z"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3241",
    d: "M105.639,95.581v1.146l-0.271,0.243l0.003-1.146L105.639,95.581z"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3241",
    d: "M105.371,95.824l-0.004,1.146l-0.221,0.2l0.002-1.146L105.371,95.824z"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A3140",
    d: "M105.148,96.024l-0.002,1.146l-7.109-6.675l0.004-1.146L105.148,96.024z"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M102.193,98.432l-0.004,1.146l-8.346-7.607l0.002-1.146L102.193,98.432z"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3140",
    d: "M100.541,97.815l-0.003,1.147l-7.398-6.746l0.003-1.146L100.541,97.815z"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3444",
    d: "M102.193,98.432l-0.004,1.146l-1.651-0.615l0.004-1.147L102.193,98.432z"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M145.091,59.059c-0.343-0.197-0.702-0.364-1.073-0.5l-60.545-22.6c-3.014-1.126-7.021-0.625-8.955,1.119 L35.724,72.096c-1.676,1.512-1.237,3.467,0.882,4.689c0.345,0.197,0.705,0.366,1.078,0.504L98.227,99.89 c3.015,1.122,7.021,0.621,8.951-1.12l38.793-35.02C147.652,62.235,147.21,60.283,145.091,59.059z M140.961,63.696l-0.518,0.469 l-2.162-2.544l-5.217,1.315l3.797,4.462l-0.519,0.467l-4.026-4.738l-5.217,1.313l4.92,5.783l2.465-0.672l-1.717,1.551l-0.519,0.465 l-0.243-0.285l-6.891,1.878l1.99,3.051l-1.842,1.665l-2.634-4.029l-9.179,2.504l4.264,6.531l2.695-0.617l-1.521,1.375l-0.592,0.136 l0.163,0.249l-0.549,0.5l-0.376-0.575l-4.885,1.118l1.779,2.6l-0.549,0.492l-1.996-2.917l-4.882,1.118l3.381,4.957l-1.829,1.648 l-4.015-5.887l-5.796,2.037l6.896,6.479l-0.49,0.443l-7.108-6.674l-4.194,1.465l8.348,7.607l-1.646-0.617l-7.398-6.744l-4.297,1.512 l1.622,1.465l-1.647-0.619l-0.67-0.607l-0.494,0.174l-1.538-0.575l1.147-0.403l-5.762-5.234l-4.275,1.553l1.435,1.301l-1.646-0.616 l-0.821-0.306l-1.53-0.572l0.989-0.365l-6.964-6.325l-4.099,1.71l2.265,2.059l-1.647-0.617l-1.281-1.162l-0.866,0.365l-2.481-0.926 l1.866-0.778l-8.562-7.776l-3.643,1.265l6.745,5.949l-5.673-2.12l-13.175-4.916l5.519-4.98l2.476-2.236l0.487-0.439l0.194-0.184 l-0.044,0.312l7.08,6.429l4.33-1.501l-8.558-7.771l0.488-0.44l8.784,7.967l4.327-1.502l-10.103-9.174l0.489-0.441l10.357,9.406 l4.646-1.281l-7.759-7.081l-1.53-2.263l-5.354,0.889l0.673-0.607l4.379-0.732l-1.354-2.003l0.549-0.495l1.848-1.668l10.796-2.263 l1.981,3.296l-7.568,2.875c0.132,0.074,0.255,0.164,0.366,0.27l8.653,8.225l4.352-1.197l-4.238-4.972 c-0.154-0.161-0.25-0.37-0.269-0.592c-0.019-0.223,0.039-0.444,0.165-0.63c0.258-0.4,0.773-0.712,1.451-0.881l8.146-2.014 l-4.551-6.669c-7.303,1.382-13.825,2.822-18.608,3.937l2.562-2.318c4.254-0.961,9.398-2.058,15.014-3.124l-4.403-6.455l1.83-1.648 l2.91,4.264l13.437-2.701l0.876,0.328l0.258,0.095l1.957,3.324c1.717-0.238,3.443-0.461,5.164-0.665l3.357,1.252 c-3.998,0.429-8.051,0.975-12.041,1.588l3.523,5.429c0.283,0.439,0.205,0.907-0.154,1.282l13.158-3.021l-3.11-4.772l3.868,1.445 l5.076,7.784l4.154-1.143l-3.982-4.68l1.342,0.5l3.381,3.978l4.188-1.152l1.357,0.507l-4.941,1.356l6.345,7.458l5.217-1.314 l-6.264-7.361l1.342,0.502l5.672,6.678l5.218-1.314l-1.617-1.898l1.343,0.5l1.028,1.21l1.318-0.333l2.776,1.036l-2.88,0.732 l1.927,2.263L140.961,63.696z"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M92.799,42.373l0.174,0.066l-0.594,0.119l-13.417,2.695l-1.31,0.264l-0.271-0.449l1.279-0.256l13.437-2.701 L92.799,42.373z"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M94.847,46.757l-0.461-0.788l-2.007-3.411l0.594-0.119l0.258,0.095l1.957,3.324l0.439,0.745L94.847,46.757z"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M93.094,54.554l-6.666,1.647l-4.455-6.533c2.631-0.48,5.346-0.947,8.102-1.384l3.578,5.513 C93.846,54.094,93.602,54.428,93.094,54.554z"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M90.074,48.282c-2.756,0.438-5.471,0.904-8.102,1.384c-0.883,0.161-1.754,0.323-2.615,0.485 c-7.303,1.382-13.825,2.822-18.608,3.936l2.562-2.317c4.254-0.961,9.398-2.058,15.014-3.124c0.86-0.163,1.733-0.326,2.613-0.487 c4.308-0.785,8.847-1.54,13.442-2.197l0.461,0.786l0.779-0.152l-0.439-0.745c1.717-0.238,3.444-0.461,5.164-0.665l3.358,1.252 c-3.999,0.429-8.052,0.974-12.041,1.588l-0.427-0.658L89.697,47.7L90.074,48.282z"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M92.379,42.558l2.012,3.411c-4.592,0.65-9.133,1.405-13.439,2.198l-1.982-2.906L92.379,42.558z"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M78.331,48.646l-4.403-6.455l1.83-1.648l2.91,4.265l-1.281,0.256l0.272,0.449l1.311-0.264l1.981,2.906 C80.063,48.321,79.191,48.489,78.331,48.646z"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M118.188,55.045l-3.984-4.681l0.997,0.372l0.344,0.128l3.384,3.978L118.188,55.045z"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M90.781,62.583l-3.74-5.483l21.445-4.925l0.345,0.529l-5.099,1.172l3.021,4.314L90.781,62.583z"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M108.82,51.587l-0.625,0.143l-3.112-4.771l3.868,1.444l5.08,7.785l-2.481,0.683l-2.719-4.166l-0.345-0.529 l0.639-0.146L108.82,51.587z"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M86.428,56.199l-2.521,0.621l-4.549-6.668c0.862-0.163,1.734-0.324,2.615-0.485L86.428,56.199z"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "M111.55,56.87l-4.796,1.32l-3.02-4.314l5.097-1.172L111.55,56.87z"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "M70.826,52.47l1.982,3.296l-7.647,2.831c-0.735-0.352-1.562-0.464-2.364-0.322l-3.01,0.5l-1.599-2.366 l1.848-1.668L70.826,52.47z"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M58.995,58.898l-1.354-2.003l0.547-0.494l1.599,2.366L58.995,58.898z"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M84.514,57.709l1.715-0.424l0.813-0.186l3.74,5.483l-2.479,0.681L84.514,57.709z"
  })), _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_23_",
    filterUnits: "userSpaceOnUse",
    x: 145.975,
    y: 61.735,
    width: 1.025,
    height: 3.16
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask24 || (_mask24 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 145.975,
    y: 61.735,
    width: 1.025,
    height: 3.16,
    id: "mask23_1101_6094"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    filter: "url(#Adobe_OpacityMaskFilter_23_)",
    d: "M147,61.735v1.146c0,0.693-0.333,1.391-1.025,2.015V63.75 C146.667,63.125,146.998,62.426,147,61.735z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_1101_6094)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#858585",
    d: "M147,61.735v1.146c0,0.693-0.333,1.391-1.025,2.015V63.75C146.667,63.125,146.998,62.426,147,61.735z"
  }))), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M138.281,61.623l-1.217-1.43l-1.614-1.898l0.206,0.076l1.135,0.426l1.027,1.208l1.218,1.429l1.925,2.263 l-0.508,0.46L138.281,61.623z"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M79.024,66.697l6.274,6.545c-2.673,0.714-5.301,1.588-7.868,2.616l-7.353-6.7l5.082-1.396l4.514,3.975 l0.686-0.262l-4.451-3.92L79.024,66.697z"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M106.421,59.162l-0.274-0.358l-0.75,0.194l0.281,0.367l-14.39,3.959l-2.479,0.682l-9.784,2.691l-3.12,0.857 l-0.412-0.363l-0.686,0.262l0.35,0.309l-5.082,1.396l-0.741-0.676l4.181-1.149l0.614,0.586l0.701-0.249l-0.57-0.542l4.352-1.198 l0.303,0.363l1.479-0.416l-0.298-0.355l8.209-2.258l2.478-0.681l15.973-4.393l4.796-1.32l2.481-0.683l4.156-1.143l0.74-0.203 l4.186-1.152l0.642,0.24l0.718,0.268l-4.938,1.357l-0.741,0.203l-4.273,1.176l-2.482,0.684L106.421,59.162z"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M125.126,63.202l-5.599,1.409l-5.008-7.678l4.273-1.176L125.126,63.202z"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M88.304,63.264l-8.209,2.255l-4.208-5.007c-0.061-0.061-0.098-0.141-0.104-0.227 c-0.008-0.085,0.016-0.17,0.064-0.24c0.137-0.18,0.336-0.301,0.559-0.34l8.1-2L88.304,63.264z"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M119.527,64.611l0.973,1.489l1.32,2.025l2.703,4.138l-2.486,0.678l-4.051-6.207l-0.973-1.49l-4.977-7.627 l2.482-0.684L119.527,64.611z"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M128.057,66.646l-6.236,1.479l-1.319-2.025l5.84-1.47L128.057,66.646z"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M126.341,64.631l-5.841,1.47l-0.973-1.489l5.599-1.409L126.341,64.631z"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M93.652,53.799l-3.578-5.514l-0.365-0.575l1.539-0.332l0.426,0.657l3.522,5.429 c0.284,0.439,0.205,0.907-0.153,1.282l-9.271,2.127l0.303,0.443l0.16-0.036l-1.717,0.423l-8.102,2 c-0.222,0.039-0.42,0.16-0.558,0.34c-0.05,0.07-0.072,0.155-0.065,0.24c0.008,0.086,0.044,0.166,0.104,0.227l4.209,5.007 l0.297,0.353l-1.477,0.418l-0.305-0.366l-4.207-4.982c-0.154-0.16-0.25-0.368-0.27-0.591c-0.019-0.223,0.04-0.444,0.166-0.629 c0.258-0.4,0.773-0.712,1.451-0.881l8.146-2.014l2.52-0.621l6.666-1.648C93.601,54.428,93.846,54.094,93.652,53.799z"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M117.014,65.244l-4.974,1.252l-5.619-7.334l5.616-1.545L117.014,65.244z"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M46.753,66.994l-0.148-0.136l0.194-0.175L46.753,66.994z"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M132.311,63.127l-1.215-1.428l-6.268-7.371l1.341,0.502l5.683,6.678l1.215,1.429l3.795,4.462l-0.346,0.313 l-0.173,0.153L132.311,63.127z"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M73.513,67.333l-8.601-8.182c-0.074-0.07-0.156-0.132-0.245-0.183c-0.502-0.259-1.076-0.344-1.632-0.244 l-2.928,0.487l-0.792,0.132l-5.354,0.891l0.673-0.608l4.379-0.732l0.792-0.132l3.01-0.5c0.803-0.143,1.629-0.029,2.364,0.322 l0.079,0.044c0.133,0.073,0.256,0.164,0.366,0.269l8.653,8.226l0.57,0.55l-0.7,0.247L73.513,67.333z"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M73.513,67.333l-4.179,1.149l-7.757-7.071l-1.488-2.197l2.928-0.487c0.556-0.1,1.13-0.015,1.632,0.244 c0.089,0.051,0.171,0.111,0.245,0.183L73.513,67.333z"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M118.792,55.758l0.742-0.203l6.344,7.457l1.215,1.428l4.921,5.783l-0.744,0.203l-3.213-3.779l-1.716-2.016 l-1.215-1.429L118.792,55.758z"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M90.859,71.832l-3.828-4.819l3.272-0.815l3.361,4.928L90.859,71.832z"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "M114.523,74.99l-10.52,2.869l-3.688-5.197l10.256-2.523L114.523,74.99z"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M97.188,71.973l15.215-3.832l4.711,6.145l-2.59,0.705l-3.951-4.852l-10.256,2.523l3.688,5.197l-2.363,0.645 L97.188,71.973z"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M91.288,63.324l4.89,7.168l1.01,1.48l4.453,6.531l-1.67,0.457l-0.771,0.275l-4.523-6.632l-1.011-1.479 l-3.361-4.928l-1.495-2.191L91.288,63.324z"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M96.178,70.492l-4.89-7.168l14.39-3.959l5.61,7.321L96.178,70.492z"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M64.684,70.642l4.642-1.278l7.43,6.771l-4.127,1.722L64.684,70.642z"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M69.326,69.363l-4.642,1.278l-0.743-0.676l4.644-1.278L69.326,69.363z"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M79.672,71.736l-4.516-3.975l-0.35-0.309l0.686-0.262l0.412,0.363l4.451,3.922L79.672,71.736z"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M112.402,68.141l-15.215,3.832l-1.01-1.48l15.11-3.806L112.402,68.141z"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "M131.27,70.426l-6.746,1.838l-2.703-4.138l6.236-1.479L131.27,70.426z"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M63.886,70.861l-4.28,1.485l-0.737-0.669l4.33-1.503l0.739,0.672L63.886,70.861z"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "M86.453,72.939c-0.386,0.1-0.771,0.198-1.154,0.303l-6.274-6.545l9.784-2.691l1.495,2.197l-3.273,0.813 l3.827,4.82L86.453,72.939z"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M113.154,67.95l4.832-1.216l4.051,6.207l-4.182,1.141L113.154,67.95z"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M50.224,75.602l6.745,5.949l-5.678-2.119l-8.048-7.098l0.397-2.801l0.538-0.484l1.938-1.749l0.527,0.478 l-0.591,4.146l3.418,3.014l-1.151,0.398l0.706,0.682L50.224,75.602z"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M46.052,71.924l0.591-4.146l6.487,5.891l-3.66,1.27L46.052,71.924z"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M50.224,75.602l-1.198,0.416l-0.707-0.682l1.151-0.398l3.66-1.27l0.738,0.671L50.224,75.602z"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M93.855,81.722l-0.377-0.408l-3.642-3.923l0.723-0.225l3.616,3.895l0.404,0.434L93.855,81.722z"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M89.837,77.391l3.64,3.923l-7.197,2.614l-7.381-6.725c2.814-1.133,5.705-2.07,8.649-2.805l7.124-1.794 l4.523,6.632l-5.023,1.832l-3.615-3.895L89.837,77.391z"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M87.551,74.398c-2.943,0.734-5.834,1.672-8.648,2.805l-1.476-1.345c2.568-1.028,5.196-1.902,7.868-2.616 c0.383-0.104,0.769-0.203,1.154-0.303l4.405-1.109l2.807-0.705l1.011,1.479L87.551,74.398z"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M126.721,76.551l-1.465,1.324l-2.633-4.038l2.484-0.677l1.99,3.052L126.721,76.551z"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "M43.243,72.334l8.048,7.098l-13.169-4.917l5.519-4.981L43.243,72.334z"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M63.886,70.861l0.051-0.015l8.024,7.288l-4.097,1.71l-8.258-7.499L63.886,70.861z"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M73.441,79.479l-4.099,1.711l-1.479-1.345l4.097-1.71L73.441,79.479z"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M54.572,74.094l4.328-1.502l8.296,7.533l-4.099,1.71L54.572,74.094z"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M63.097,81.835l4.099-1.71l1.479,1.342l-4.099,1.713L63.097,81.835z"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M117.708,82.871l2.694-0.615l-0.387,0.35l-1.136,1.024l-0.591,0.136L117.708,82.871z"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M63.044,83.818l-2.479-0.927l1.867-0.778l1.478,1.342L63.044,83.818z"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M107.732,77.898l4.967-1.355l4.244,6.504l-4.912,1.125L107.732,77.898z"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M60.839,61.627l-1.542-2.283l0.792-0.13l1.487,2.199l7.757,7.069l0.741,0.676l7.353,6.7l1.475,1.345 l7.378,6.725l-0.697,0.253l-7.352-6.702l-1.476-1.344l-7.429-6.771l-0.741-0.676L60.839,61.627z"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M117.523,83.939l-4.885,1.119l-0.607-0.887l4.912-1.125L117.523,83.939z"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M64.576,83.18l2.267,2.056l-1.652-0.615l-1.281-1.163l-1.479-1.344l-8.563-7.774l-0.738-0.671l-6.487-5.891 L46.116,67.3l0.489-0.441l0.148,0.136l7.082,6.429l0.737,0.671l8.525,7.741L64.576,83.18z"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M102.247,79.393l4.743-1.293l4.277,6.246l-4.879,1.117L102.247,79.393z"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M63.937,70.847l-0.739-0.672l-10.104-9.174l0.489-0.441l10.359,9.406l0.743,0.676l7.945,7.215l1.48,1.344 l7.195,6.533l-0.695,0.253l-7.168-6.508l-1.48-1.344L63.937,70.847z"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M74.109,79.2l4.121-1.722l7.352,6.702l-4.277,1.553L74.109,79.2z"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M103.925,86.166l-4.111-6.028l0.903-0.327l1.53-0.418l4.142,6.07l-1.273,0.293l-0.064,0.014L103.925,86.166z "
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M58.899,72.592l-0.738-0.67l-8.558-7.771l0.49-0.441l8.774,7.969l0.737,0.669l8.258,7.498l1.479,1.345 l6.992,6.35l-0.695,0.253l-6.964-6.325l-1.479-1.342L58.899,72.592z"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M111.268,84.346L106.99,78.1l-0.313-0.457l0.76-0.175l0.295,0.431l4.299,6.273l0.607,0.887l1.78,2.598 l-0.547,0.492l-1.996-2.914L111.268,84.346z"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "M76.689,88.912l-0.511-0.189l0.346-0.127L77,89.027L76.689,88.912z"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M106.389,85.463l4.879-1.117l0.608,0.889l-4.882,1.116l-1.206,0.276l-1.25,0.438l-5.795,2.038l-0.866-0.812 l6.048-2.125l1.125-0.396l0.065-0.014L106.389,85.463z"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M77.22,88.343l1.435,1.302l-0.306-0.113L77,89.027l-0.476-0.432L77.22,88.343z"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M87.162,84.732l4.298-1.561l5.715,5.367l-4.21,1.479L87.162,84.732z"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M92.26,90.268l-5.793-5.281l0.697-0.254l5.801,5.286L92.26,90.268z"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M82.189,86.539l4.277-1.553l5.793,5.281l-4.299,1.511L82.189,86.539z"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M105.788,86.627l1.206-0.276l3.381,4.957l-1.82,1.644l-4.017-5.887L105.788,86.627z"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M87.65,93.003l-1.541-0.575l1.148-0.402l0.703-0.247l4.299-1.511l0.703-0.249l4.211-1.479l0.866,0.811 l-4.194,1.475l-0.702,0.247l-4.297,1.511l-0.702,0.247L87.65,93.003z"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M88.847,92.582l1.621,1.475l-1.655-0.619l-0.668-0.608L88.847,92.582z"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M97.176,88.539l-5.716-5.367l-0.434-0.406l0.7-0.251l0.431,0.404l5.72,5.372l0.865,0.812l6.898,6.479 l-0.27,0.243l-0.223,0.2L98.04,89.35L97.176,88.539z"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fill: "#515E7A",
    d: "M93.846,90.824l8.348,7.607l-1.651-0.616l-7.398-6.744L93.846,90.824z"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fill: "#898989",
    d: "M145.975,63.75l-0.004,1.147L107.18,99.916l0.002-1.146L145.975,63.75z"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fill: "#8D8D8D",
    d: "M98.23,99.89l-0.004,1.146L37.684,78.435l0.003-1.146L98.23,99.89z"
  })), _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_24_",
    filterUnits: "userSpaceOnUse",
    x: 98.238,
    y: 98.77,
    width: 8.943,
    height: 2.865
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask25 || (_mask25 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 98.238,
    y: 98.77,
    width: 8.943,
    height: 2.865,
    id: "mask24_1101_6094"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    filter: "url(#Adobe_OpacityMaskFilter_24_)",
    d: "M107.182,98.77v1.146c-1.93,1.741-5.938,2.243-8.951,1.12 V99.89C101.244,101.012,105.248,100.511,107.182,98.77z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_1101_6094)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#858585",
    d: "M107.182,98.77v1.146c-0.531,0.463-1.143,0.826-1.804,1.073v-1.147 C106.038,99.595,106.648,99.231,107.182,98.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8A8A8A",
    d: "M105.378,99.842v1.147c-1.647,0.647-3.751,0.825-5.673,0.454v-1.146 C101.631,100.664,103.73,100.48,105.378,99.842z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#858585",
    d: "M99.701,100.298v1.146c-0.498-0.094-0.987-0.231-1.463-0.407V99.89 C98.715,100.064,99.203,100.201,99.701,100.298z"
  }))), _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_25_",
    filterUnits: "userSpaceOnUse",
    x: 86.768,
    y: 11.484,
    width: 10.646,
    height: 19.707
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask26 || (_mask26 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 86.768,
    y: 11.484,
    width: 10.646,
    height: 19.707,
    id: "mask25_1101_6094"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    filter: "url(#Adobe_OpacityMaskFilter_25_)",
    d: "M88.962,13.303l3.13-1.818 c-1.356,0.788-2.196,2.463-2.196,4.845c-0.013,4.794,3.357,10.633,7.526,13.041l-3.127,1.82c-4.169-2.408-7.541-8.24-7.527-13.041 C86.766,15.768,87.607,14.09,88.962,13.303z"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_1101_6094)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#835C1F",
    d: "M88.962,13.303l3.13-1.818c-1.356,0.788-2.196,2.463-2.196,4.845c0.007,1.092,0.155,2.179,0.444,3.232 l-3.127,1.818c-0.289-1.053-0.438-2.139-0.445-3.23c0-2.38,0.848-4.06,2.196-4.847H88.962z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#885F20",
    d: "M87.205,21.38l3.127-1.818c0.131,0.487,0.285,0.976,0.465,1.465l-3.127,1.82 c-0.184-0.485-0.335-0.974-0.465-1.465V21.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8D6321",
    d: "M87.67,22.841l3.127-1.82c0.152,0.405,0.318,0.808,0.5,1.205l-3.127,1.818 C87.986,23.646,87.82,23.245,87.67,22.841z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#926622",
    d: "M88.17,24.044l3.127-1.818c0.168,0.366,0.352,0.728,0.549,1.084l-3.127,1.818 C88.526,24.773,88.353,24.41,88.17,24.044z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#976A23",
    d: "M88.711,25.128l3.128-1.818c0.183,0.348,0.388,0.69,0.599,1.023l-3.128,1.82 C89.099,25.819,88.899,25.478,88.711,25.128z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9C6D25",
    d: "M89.31,26.154l3.128-1.82c0.215,0.343,0.441,0.677,0.676,1.003l-3.127,1.818 C89.75,26.831,89.523,26.496,89.31,26.154z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A17126",
    d: "M89.986,27.155l3.127-1.818c0.254,0.35,0.519,0.687,0.793,1.013l-3.129,1.818 C90.503,27.844,90.239,27.505,89.986,27.155z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A67427",
    d: "M90.777,28.168l3.129-1.818c0.326,0.386,0.668,0.756,1.021,1.099l-3.127,1.818 C91.447,28.92,91.105,28.552,90.777,28.168z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7828",
    d: "M91.801,29.27l3.127-1.818c0.614,0.61,1.289,1.158,2.013,1.633l-3.13,1.818 c-0.723-0.476-1.396-1.023-2.012-1.633H91.801z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B07B29",
    d: "M93.818,30.903l3.129-1.818c0.154,0.101,0.309,0.195,0.467,0.286l-3.127,1.82 C94.129,31.1,93.975,31.008,93.818,30.903z"
  }))), _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_26_",
    filterUnits: "userSpaceOnUse",
    x: 94.287,
    y: 29.371,
    width: 8.5,
    height: 2.856
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask27 || (_mask27 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 94.287,
    y: 29.371,
    width: 8.5,
    height: 2.856,
    id: "mask26_1101_6094"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    filter: "url(#Adobe_OpacityMaskFilter_26_)",
    d: "M102.787,29.898l-3.127,1.82 c-1.373,0.798-3.273,0.685-5.373-0.527l3.127-1.82C99.514,30.585,101.414,30.696,102.787,29.898z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_1101_6094)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B07B29",
    d: "M94.287,31.191l3.127-1.82c0.23,0.134,0.459,0.255,0.687,0.366l-3.129,1.82 C94.746,31.449,94.518,31.33,94.287,31.191z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7828",
    d: "M94.972,31.552l3.129-1.82c0.622,0.306,1.288,0.515,1.972,0.623l-3.126,1.818 C96.261,32.065,95.596,31.856,94.972,31.552z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A67427",
    d: "M96.945,32.172l3.127-1.818c0.337,0.05,0.677,0.066,1.017,0.046l-3.128,1.818 C97.622,32.238,97.281,32.223,96.945,32.172z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A17126",
    d: "M97.961,32.218l3.128-1.818c0.267-0.017,0.531-0.06,0.79-0.126l-3.129,1.818 C98.492,32.161,98.229,32.203,97.961,32.218z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9C6D25",
    d: "M98.75,32.092l3.129-1.818c0.229-0.061,0.451-0.143,0.664-0.245l-3.129,1.82 C99.201,31.951,98.979,32.032,98.75,32.092z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#976A23",
    d: "M99.414,31.848l3.13-1.82c0.082-0.041,0.164-0.083,0.243-0.13l-3.127,1.82 C99.579,31.764,99.498,31.808,99.414,31.848z"
  }))), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    fill: "#7E581E",
    d: "M106.104,41.861l3.127-1.82L97.354,50.608l-3.128,1.818L106.104,41.861z"
  })), _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_27_",
    filterUnits: "userSpaceOnUse",
    x: 82.924,
    y: 0.001,
    width: 14.572,
    height: 4.025
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask28 || (_mask28 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 82.924,
    y: 0.001,
    width: 14.572,
    height: 4.025,
    id: "mask27_1101_6094"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    filter: "url(#Adobe_OpacityMaskFilter_27_)",
    d: "M82.924,2.906l3.127-1.818 c2.928-1.701,6.971-1.465,11.438,1.121L94.36,4.026C89.897,1.446,85.852,1.207,82.924,2.906z"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_1101_6094)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#976A23",
    d: "M82.924,2.906l3.127-1.818c0.17-0.099,0.344-0.192,0.521-0.278l-3.127,1.82 C83.262,2.714,83.094,2.813,82.924,2.906z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9C6D25",
    d: "M83.449,2.629l3.127-1.82c0.453-0.218,0.927-0.393,1.413-0.521l-3.128,1.818 C84.375,2.235,83.902,2.41,83.449,2.629z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A17126",
    d: "M84.861,2.107l3.128-1.818c0.55-0.145,1.113-0.235,1.682-0.269l-3.128,1.818 C85.976,1.874,85.412,1.964,84.861,2.107z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A67427",
    d: "M86.543,1.838l3.128-1.818c0.722-0.043,1.446-0.011,2.161,0.097l-3.127,1.822 c-0.716-0.106-1.439-0.138-2.162-0.097V1.838z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7828",
    d: "M88.705,1.939l3.127-1.818c1.461,0.229,2.879,0.675,4.209,1.324l-3.13,1.818 c-1.329-0.65-2.747-1.096-4.208-1.324H88.705z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B07B29",
    d: "M92.904,3.259l3.129-1.818C96.512,1.668,97,1.924,97.496,2.208l-3.127,1.818 c-0.488-0.283-0.976-0.539-1.463-0.767H92.904z"
  }))), _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_28_",
    filterUnits: "userSpaceOnUse",
    x: 94.364,
    y: 2.208,
    width: 19.149,
    height: 39.653
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask29 || (_mask29 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 94.364,
    y: 2.208,
    width: 19.149,
    height: 39.653,
    id: "mask28_1101_6094"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    filter: "url(#Adobe_OpacityMaskFilter_28_)",
    d: "M94.364,4.026l3.128-1.818 c8.88,5.127,16.051,17.563,16.021,27.772c-0.013,4.827-1.646,8.292-4.283,10.06l-3.127,1.82c2.646-1.771,4.271-5.233,4.283-10.071 C110.416,21.588,103.234,9.157,94.364,4.026z"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_1101_6094)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B07B29",
    d: "M94.364,4.026l3.128-1.818c0.335,0.192,0.666,0.395,0.994,0.61l-3.119,1.818 c-0.33-0.212-0.662-0.416-0.996-0.61H94.364z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7828",
    d: "M95.367,4.636l3.127-1.818c1.546,1.014,2.986,2.179,4.301,3.479l-3.127,1.82 c-1.315-1.299-2.756-2.465-4.301-3.479V4.636z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A67427",
    d: "M99.66,8.115l3.127-1.82c0.753,0.732,1.479,1.515,2.176,2.349l-3.129,1.818 C101.139,9.638,100.414,8.855,99.66,8.115z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A17126",
    d: "M101.834,10.463l3.129-1.818c0.584,0.69,1.146,1.408,1.684,2.153l-3.127,1.818 C102.98,11.873,102.42,11.155,101.834,10.463z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9C6D25",
    d: "M103.52,12.616l3.127-1.818c0.502,0.692,0.981,1.403,1.439,2.133l-3.127,1.826 c-0.457-0.732-0.938-1.444-1.439-2.133V12.616z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#976A23",
    d: "M104.959,14.757l3.127-1.818c0.448,0.713,0.875,1.44,1.281,2.181l-3.127,1.818 C105.839,16.198,105.412,15.471,104.959,14.757z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#926622",
    d: "M106.232,16.93l3.127-1.818c0.41,0.758,0.795,1.527,1.154,2.306l-3.13,1.82 C107.025,18.46,106.643,17.691,106.232,16.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8D6321",
    d: "M107.384,19.237l3.13-1.82c0.387,0.847,0.741,1.702,1.063,2.563l-3.127,1.818 c-0.32-0.861-0.676-1.718-1.065-2.564V19.237z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#885F20",
    d: "M108.449,21.801l3.127-1.818c0.383,1.033,0.713,2.07,0.99,3.113l-3.127,1.82 c-0.277-1.038-0.608-2.078-0.99-3.113V21.801z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#835C1F",
    d: "M109.439,24.912l3.127-1.82c0.615,2.245,0.934,4.561,0.947,6.889c-0.013,4.827-1.646,8.291-4.283,10.06 l-3.127,1.82c2.646-1.771,4.271-5.233,4.283-10.071c-0.015-2.327-0.334-4.642-0.947-6.887V24.912z"
  }))), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fill: "#DB9A34",
    d: "M94.364,4.026c8.879,5.127,16.052,17.562,16.022,27.772c-0.013,4.829-1.638,8.291-4.283,10.071 L94.227,52.436L82.447,28.203c-2.623-4.814-4.223-10.141-4.208-14.969C78.267,3.014,85.486-1.103,94.364,4.026z M94.287,31.191 c4.17,2.41,7.561,0.476,7.574-4.318c0.013-4.793-3.354-10.635-7.526-13.044c-4.173-2.41-7.562-0.476-7.573,4.321 C86.748,22.947,90.119,28.783,94.287,31.191z"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#132442",
    d: "M48.188,57.27l-11.415,6.637l-11.49-6.637l11.415-6.638L48.188,57.27z"
  }))), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fill: "#A48157",
    d: "M48.188,42.212l-0.037,12.867l-11.415,6.638l0.037-12.867L48.188,42.212z"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8A376",
    d: "M36.773,48.85l-0.037,12.867l-11.49-6.638l0.037-12.867L36.773,48.85z"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3C095",
    d: "M48.188,42.212L36.773,48.85l-11.49-6.638l11.415-6.638L48.188,42.212z"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fill: "#6B573F",
    d: "M35.753,60.158l-0.002,0.395l-3.939-2.276l0.002-0.394L35.753,60.158z"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    fill: "#6B573F",
    d: "M33.793,55.575l1.964,3.404l-1.373-0.793l-0.004,1.013l-0.596-0.346l-0.601-0.347l0.004-1.013l-1.371-0.791 L33.793,55.575z"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    fill: "#808080",
    d: "M29.836,46.264l0.192-0.113l-0.008,2.669l-0.192,0.112L29.836,46.264z"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    d: "M26.419,44.29l0.192-0.111l3.416,1.972l-0.192,0.113L26.419,44.29z"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fill: "#D3D3D3",
    d: "M29.836,46.264l-0.007,2.668l-3.417-1.972l0.007-2.67L29.836,46.264z"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5C5",
    d: "M42.619,45.44l1.413-0.822l-0.037,12.974l-1.413,0.82L42.619,45.44z"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCDCDC",
    d: "M30.972,38.711l1.413-0.822l11.647,6.729l-1.413,0.822L30.972,38.711z"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fill: "#898989",
    d: "M42.619,45.44l-0.037,12.972l-0.119-0.068L42.5,45.508l-11.528-6.66v-0.137L42.619,45.44z"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#132442",
    d: "M29.693,69.475l-14.774,8.594L0.047,69.475l14.774-8.591L29.693,69.475z"
  }))), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    fill: "#A48157",
    d: "M29.693,49.985l-0.047,16.653l-14.774,8.594l0.047-16.654L29.693,49.985z"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8A376",
    d: "M14.919,58.578l-0.048,16.654L0,66.639l0.047-16.652L14.919,58.578z"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3C095",
    d: "M29.693,49.985l-14.774,8.593L0.047,49.987l14.774-8.593L29.693,49.985z"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    fill: "#6B573F",
    d: "M13.6,73.215l-0.001,0.51l-5.1-2.945L8.5,70.268L13.6,73.215z"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    fill: "#6B573F",
    d: "M11.062,67.283l2.542,4.406l-1.777-1.027l-0.003,1.311l-0.772-0.447l-0.776-0.447l0.003-1.31l-1.775-1.026 L11.062,67.283z"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5C5",
    d: "M22.487,54.164l1.828-1.064l-0.047,16.793l-1.828,1.063L22.487,54.164z"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCDCDC",
    d: "M7.411,45.453l1.828-1.064l15.076,8.71l-1.828,1.064L7.411,45.453z"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    fill: "#898989",
    d: "M22.487,54.164L22.44,70.955l-0.156-0.09l0.048-16.613L7.411,45.631v-0.178L22.487,54.164z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdrImg);
export default __webpack_public_path__ + "static/media/adrImg.65dcf33b5854206ce7dbcb1d2fc8139c.svg";
export { ForwardRef as ReactComponent };